<template>
  <div class="material">
    <div class="main-form">
      <div class="top-tabs">
        <div class="tab-list">
          <div
            @click="change_tab1('default')"
            :class="['tab-item', { active: current_tab1 === 'default' }]"
          >
            平台面料
          </div>
          |
          <div
            @click="change_tab1('self')"
            :class="['tab-item', { active: current_tab1 === 'self' }]"
          >
            自己提供面料
          </div>
          |
          <div
            @click="change_tab1('daigou')"
            :class="['tab-item', { active: current_tab1 === 'daigou' }]"
          >
            代购面料
          </div>
        </div>
        <div class="tab-history" @click="onShowHistory">
          使用记录 <Icon type="ios-arrow-forward" color="#999" size="12px" />
        </div>
      </div>
      <div class="tips">*1.面料A为主面料</div>
      <div v-if="current_tab1 === 'self'" class="self-tab-box">
        <div :class="['self-tab-item',{active:current_tab2 === 's1'}]" @click="change_tab2('s1')">自己寄出面料</div>
        <div :class="['self-tab-item',{active:current_tab2 === 's2'}]" @click="change_tab2('s2')">第三方采买面料</div>
      </div>
      <div class="tips-third" v-if="current_tab1 === 'self' && current_tab2 === 's2'">
        <p>可进入右侧第三方平台选购所需面料后</p>
        <p>点击 [添加面料] 将面料信息提交平台</p>
      </div>
      <div class="material-list">
        <template v-if="current_tab1 === 'default'">
          <div class="own-material-item" v-for="(v,k) in form_data.material" :key="`material-${k}`">
            <Icon type="md-close" class="remove-icon" @click.stop="del_material(k)" />
            <div class="main-info">
              <div class="main-cover">
                <img :src="v.image | default_img" v-viewer />
                <select
                  :value="form_data.material[k].alias"
                  @change="input2($event, 'material', k, 'alias')"
                >
                  <option value="">请选择</option>
                  <option value="面料A">面料A</option>
                  <option value="面料B">面料B</option>
                  <option value="面料C">面料C</option>
                  <option value="面料D">面料D</option>
                  <option value="面料E">面料E</option>
                  <option value="面料F">面料F</option>
                  <option value="面料G">面料G</option>
                  <option value="面料H">面料H</option>
                  <option value="面料I">面料I</option>
                  <option value="面料J">面料J</option>
                  <option value="里料A">里料A</option>
                  <option value="里料B">里料B</option>
                  <option value="里料C">里料C</option>
                  <option value="里料D">里料D</option>
                  <option value="里料E">里料E</option>
                  <option value="里料F">里料F</option>
                </select>
              </div>
              <div class="info-container">
                <div class="material-title">{{ v.fabric_name_cn }}</div>
                <div class="row-1-col">
                  <div class="row-label">编号:</div>
                  <div class="row-value">{{ v.fabric_key }}</div>
                </div>
                <div class="row-2-col">
                  <div class="col-item">
                    <div class="item-label">幅宽:</div>
                    <div class="item-value">{{ v.width_desc }}</div>
                  </div>
                  <div class="col-item">
                    <div class="item-label">克重:</div>
                    <div class="item-value">{{v.weight}}</div>
                  </div>
                </div>
                <div class="row-1-col">
                  <div class="row-label">成分:</div>
                  <div class="row-value">{{v.component}}</div>
                </div>
                <div class="row-1-col">
                  <div class="row-label">颜色:</div>
                  <div class="row-value">
                    <select
                      :value="form_data.material[k].color_key"
                      @input="change3($event, 'material', k, 'color_key')"
                    >
                      <option
                        v-for="(vv, kk) in form_data.material[k].color_list"
                        :key="kk"
                        :value="vv.color_key"
                      >
                        {{ vv.color_name_cn }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
            <div class="use-desc">
              <div class="label">使用说明:</div>
              <input type="text" placeholder="请输入使用说明" :value="form_data.material[k].desc"
              @input="input2($event, 'material', k, 'desc')" />
            </div>
          </div>
        </template>
        <template v-else-if="current_tab1 === 'self'">
          <div class="custom-material-item" v-for="(v, k) in form_data.material_self"
          :key="`ms` + k">
            <Icon type="md-close" class="remove-icon" @click.stop="del_material_self(k)" />
            <div class="custom-main-info">
              <div class="main-cover">
                <Upload
                :action="upload_url"
                :data="{ dir: 'template' }"
                :before-upload="(file) => onBeforeUpload(file, k)"
                :show-upload-list="false"
                :format="['jpg', 'jpeg', 'png', 'gif']"
                accept=".jpg,.jpeg,.png,.gif"
              >
                <template v-if="v.image">
                  <div class="img-box">
                    <img @click.stop :src="v.image" class="img" v-viewer />
                    <div class="replace-btn">
                      <img
                        src="@/assets/images/icon-file-upload.png"
                        alt=""
                        class="ico"
                      />
                      重新上传
                    </div>
                  </div>
                </template>
                <template v-else>
                  <div class="img-default">
                    <img
                      class="img2"
                      src="@/assets/images/design/icon-add.png"
                    />
                    <p>上传图案</p>
                  </div>
                </template>
              </Upload>
              <select
                :value="form_data.material_self[k].alias"
                @change="input2($event, 'material_self', k, 'alias')"
                style="border: none; outline: none"
              >
                <option value="">请选择</option>
                <option value="面料A">面料A</option>
                <option value="面料B">面料B</option>
                <option value="面料C">面料C</option>
                <option value="面料D">面料D</option>
                <option value="面料E">面料E</option>
                <option value="面料F">面料F</option>
                <option value="面料G">面料G</option>
                <option value="面料H">面料H</option>
                <option value="面料I">面料I</option>
                <option value="面料J">面料J</option>
                <option value="里料A">里料A</option>
                <option value="里料B">里料B</option>
                <option value="里料C">里料C</option>
                <option value="里料D">里料D</option>
                <option value="里料E">里料E</option>
                <option value="里料F">里料F</option>
              </select>
              </div>
              <div class="custom-main-form">
                <div class="form-item">
                  <div class="item-label required">名称:</div>
                  <input type="text" placeholder="面料名称" :value="form_data.material_self[k].fabric_name_cn"
                    @input="
                      input2($event, 'material_self', k, 'fabric_name_cn')
                    " />
                </div>
                <div class="form-item">
                  <div class="item-label">编号:</div>
                  <input type="text" placeholder="面料编号" :value="form_data.material_self[k].fabric_key"
                  @input="input2($event, 'material_self', k, 'fabric_key')" />
                </div>
                <div class="form-item">
                  <div class="item-label">幅宽:</div>
                  <input type="text" placeholder="幅宽,单位:cm" :value="form_data.material_self[k].width_wide"
                  @input="input2($event, 'material_self', k, 'width_wide')" />
                </div>
                <div class="form-item">
                  <div class="item-label">成分:</div>
                  <input type="text" placeholder="成分" :value="form_data.material_self[k].component"
                  @input="input2($event, 'material_self', k, 'component')" />
                </div>
                <div class="form-item">
                  <div class="item-label">颜色:</div>
                  <input type="text" placeholder="颜色"  :value="form_data.material_self[k].color_name"
                  @input="input2($event, 'material_self', k, 'color_name')" />
                </div>
              </div>
            </div>
            <div class="use-desc">
              <div class="label">使用说明:</div>
              <input type="text" placeholder="请输入使用说明" :value="form_data.material_self[k].desc"
              @input="input2($event, 'material_self', k, 'desc')" />
            </div>
          </div>
          <div class="add-custom-material" @click="add_material_self">
            + 添加面料
          </div>
        </template>
        <template v-else-if="current_tab1 === 'daigou'">
          <div class="custom-material-item" v-for="(v, k) in form_data.material_daigou"
          :key="`mdg` + k">
            <Icon type="md-close" class="remove-icon" @click.stop="del_material_daigou(k)" />
            <div class="custom-main-info">
              <div class="main-cover">
                <template v-if="v.image_list && v.image_list.length">
                  <div class="img-box">
                    <Icon class="prev-btn" type="ios-arrow-back" @click.stop="switchImage(k,'left')"></Icon>
                    <Icon class="next-btn" type="ios-arrow-forward" @click.stop="switchImage(k,'right')"></Icon>
                    <div class="img-list" v-viewer @click.stop>
                      <template v-for="(img,ii) in v.image_list">
                        <img :key="ii" v-show="ii === (v.currentImageIndex || 0)" :src="img" class="img" />
                        <Icon type="ios-close-circle-outline" class="close-btn" @click.stop="onDelImg(k,ii)" />
                      </template>
                    </div>
                  </div>
                </template>
                <template v-else>
                  <div class="img-default" title="点击下方按钮上传图片">
                    <img
                      :src="''|default_img"
                    />
                  </div>
                </template>
                <Upload
                :action="upload_url"
                :data="{ dir: 'template' }"
                :before-upload="(file) => onBeforeUpload2(file, k)"
                :show-upload-list="false"
                :format="['jpg', 'jpeg', 'png', 'gif']"
                accept=".jpg,.jpeg,.png,.gif" multiple
              >
                <Button title="点此上传" type="text">{{v.image_list && v.image_list.length > 0 ? '添加':'上传'}}图片</Button>
              </Upload>
              <select
                :value="form_data.material_daigou[k].alias"
                @change="input2($event, 'material_daigou', k, 'alias')"
                style="border: none; outline: none"
              >
                <option value="">请选择</option>
                <option value="面料A">面料A</option>
                <option value="面料B">面料B</option>
                <option value="面料C">面料C</option>
                <option value="面料D">面料D</option>
                <option value="面料E">面料E</option>
                <option value="面料F">面料F</option>
                <option value="面料G">面料G</option>
                <option value="面料H">面料H</option>
                <option value="面料I">面料I</option>
                <option value="面料J">面料J</option>
                <option value="里料A">里料A</option>
                <option value="里料B">里料B</option>
                <option value="里料C">里料C</option>
                <option value="里料D">里料D</option>
                <option value="里料E">里料E</option>
                <option value="里料F">里料F</option>
              </select>
              </div>
              <div class="custom-main-form">
                <div class="form-item">
                  <div class="item-label required">名称:</div>
                  <input type="text" placeholder="面料名称" :value="form_data.material_daigou[k].fabric_name_cn"
                    @input="
                      input2($event, 'material_daigou', k, 'fabric_name_cn')
                    " />
                </div>
                <div class="form-item">
                  <div class="item-label">编号:</div>
                  <input type="text" placeholder="面料编号" :value="form_data.material_daigou[k].fabric_key"
                  @input="input2($event, 'material_daigou', k, 'fabric_key')" />
                </div>
                <div class="form-item">
                  <div class="item-label">幅宽:</div>
                  <input type="text" placeholder="幅宽,单位:cm" :value="form_data.material_daigou[k].width_wide"
                  @input="input2($event, 'material_daigou', k, 'width_wide')" />
                </div>
                <div class="form-item">
                  <div class="item-label">成分:</div>
                  <input type="text" placeholder="成分" :value="form_data.material_daigou[k].component"
                  @input="input2($event, 'material_daigou', k, 'component')" />
                </div>
                <div class="form-item">
                  <div class="item-label">颜色:</div>
                  <input type="text" placeholder="颜色"  :value="form_data.material_daigou[k].color_name"
                  @input="input2($event, 'material_daigou', k, 'color_name')" />
                </div>
              </div>
            </div>
            <div class="use-desc">
              <div class="label">使用说明:</div>
              <input type="text" placeholder="请输入使用说明" :value="form_data.material_daigou[k].desc"
              @input="input2($event, 'material_daigou', k, 'desc')" />
            </div>
          </div>
          <div class="add-custom-material" @click="add_material_daigou">
            + 添加面料
          </div>
        </template>
      </div>

      <div class="main-form-title mt-40">面料附件上传</div>
      <Upload
        :action="upload_url"
        :data="{ dir: 'template' }"
        :before-upload="(file) => onBeforeUpload3(file)"
        :show-upload-list="false"
      >
        <div class="upload-other">
          <img
            class="icon"
            src="@/assets/images/design/icon-upload-black.png"
            alt=""
          />
          上传文件
        </div>
      </Upload>
      <div class="other-file-list">
        <div
          class="file-box"
          v-for="(v, k) in form_data.material_file"
          :key="`of` + k"
        >
          <a :href="v.path" class="file-item" target="_blank">
            <img :src="util.get_image_icon(v.name)" class="icon-doc" />
            {{ v.name }}
          </a>

          <img
            class="icon-del cursor"
            src="@/assets/images/design/icon-del.png"
            @click.prevent="del_material_file(k)"
            alt=""
          />
        </div>
      </div>
    </div>
    <div class="main-content">
      <div class="content-body">
        <div class="body-top" v-if="current_tab2 != 's2'">
          <div class="title">{{ current_tab1 | body_title_filter(current_tab2,is_show_history) }}</div>
          <div v-if="!is1688 && current_tab1 != 'daigou'" class="search-box">
            <input
              v-model="form_data_fabric.keyword"
              placeholder="输入关键词进行搜索面料"
              type="text"
              @keyup.enter="search_fabric"
            />
            <img
              alt=""
              class="icon-search"
              src="@/assets/images/icon-search.png"
              @click="search_fabric"
            />
          </div>
        </div>
        <template v-if="current_tab1 != 'daigou' && !is_show_history && current_tab2 == 's1'">
          <div class="content-container">
            <template v-if="is_loading">
              <Spin fix>
                  <Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon>
                  <div>Loading</div>
              </Spin>
            </template>
            <template v-if="current_tab1 == 'default'">
              <div class="side-category-list">
                <div
                  v-for="(v, k) in fabric_category_list"
                  :key="`dc` + k"
                  :class="[
                    'category-item',
                    { active: current_fabric_category_id === v.fabric_category_id },
                  ]"
                  @click="choose_fabric_category(v)"
                >
                  {{ v.category_name }}
                </div>
              </div>
              <div class="content-body-container">
                <div :class="['top-category-list',{'show-first':!show_all_cate}]">
                  <div class="flex-container">
                    <div class="top-cate-item">
                      <div class="top-cate-label">发布:</div>
                      <div class="top-cate-list">
                        <div
                          :class="[
                            'cate-list-item',
                            { active: publish_time_selected.includes(vv.value) },
                          ]"
                          v-for="(vv, kk) in publish_time_list"
                          :key="`lf2-${kk}`"
                          @click="choose_publish_time(vv)"
                        >
                          {{ vv.name }}
                        </div>
                      </div>
                    </div>
                    <div :class="['show-more-cate',{'show-all':show_all_cate}]" @click="show_all_cate=!show_all_cate">{{!show_all_cate ? '展开' :'收起'}}筛选 <Icon :type="!show_all_cate ? 'ios-arrow-down':'ios-arrow-up'" /> </div>
                  </div>
                  <div class="top-cate-item">
                    <div class="top-cate-label">类型:</div>
                    <div class="top-cate-list">
                      <div
                        :class="[
                          'cate-list-item',
                          { active: form_data_fabric.type === 1 },
                        ]"
                        @click="choose_fabric_type(1)"
                      >
                        面料
                      </div>
                      <div
                        :class="[
                          'cate-list-item',
                          { active: form_data_fabric.type === 2 },
                        ]"
                        @click="choose_fabric_type(2)"
                      >
                        里料
                      </div>
                    </div>
                  </div>
                  <div
                    class="top-cate-item"
                    v-for="(v, k) in fabric_label_list"
                    :key="`lf1-${k}`"
                  >
                    <div class="top-cate-label">{{ v.label_name }}:</div>
                    <div class="top-cate-list">
                      <div
                        v-for="(vv, kk) in v.content"
                        :class="[
                          'cate-list-item',
                          { active: fabric_label_ids.includes(vv.id) },
                        ]"
                        :key="`lf2-${kk}`"
                        @click="choose_label(vv)"
                      >
                        {{ vv.name }}
                      </div>
                    </div>
                  </div>
                </div>
                <div class="list-container">
                  <div
                    v-for="(v, k) in fabric_list"
                    :class="['list-item', { active: selected_ids.includes(v.id) }]"
                    @click="open_fabric_detail(v)"
                    :key="`df-${k}`"
                  >
                    <img
                      v-if="selected_ids.includes(v.id)"
                      alt=""
                      class="check-icon"
                      src="@/assets/images/icon-check.png"
                    />
                    <div class="cover-img-box">
                      <img :src="v.image | default_img" />
                      <div class="img-hover">
                        <div class="hover-btn-box">
                          <div
                            class="hover-btn-item"
                            @click.stop="open_fabric_detail(v)"
                          >
                            查看
                          </div>
                          <div
                            class="hover-btn-item"
                            @click.stop="toggle_material(v)"
                            v-if="selected_ids.includes(v.id)"
                          >
                            取消
                          </div>
                          <div
                            class="hover-btn-item"
                            @click.stop="toggle_material(v)"
                            v-else
                          >
                            选择
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="name-box"><span>{{ v.fabric_name_cn }}</span></div>
                  </div>
                </div>
                <Page
                    :current="form_data_fabric.page"
                    v-if="total > 0"
                    :page-size="form_data_fabric.size"
                    :total="total"
                    @on-change="changePage"
                    show-total
                ></Page>
              </div>
            </template>
            <template v-else-if="current_tab2 == 's1' && !is_show_history">
              <div class="wearhouse-body">
                <div class="container-tabs">
                  <div v-for="(item,index) in wear_tabs" :key="`wh-index-${index}`" :class="['tab-item',{active:item.status == query_wear_house.status}]" @click="onWhTabClick(item)">{{item.name}}{{ item.has_count ? `(${item.count})` :'' }}</div>
                </div>
                <div class="container-wh-list">
                  <div class="list-item" v-for="(item,index) in wh_list" :key="`wh-list-index-${index}`">
                    <div class="cover-img">
                      <img :src="item.image|default_img" alt="" />
                      <div class="operate-btn">
                        <div class="btn-item" @click.stop="onWhDetailClick(item)">查看</div>
                        <div class="btn-item" @click.stop="onChooseWhItem(item)">选择</div>
                      </div>
                    </div>
                    <div class="item-name">{{item.name}}</div>
                  </div>
                </div>
                <Page
                  :current="query_wear_house.page"
                  v-if="total > 0"
                  :page-size="query_wear_house.limit"
                  :total="total"
                  @on-change="changeWhPage"
                  show-total
                  style="margin-top: 20px"
                ></Page>
              </div>
            </template>
            <div v-show="is_color_show" class="color-mask">
              <div class="color-wrap">
                <h2 class="title">颜色选择</h2>
                <!-- 隐藏的image_list图片，用于rgb色块点击时查看 -->
                <div v-viewer class="hidden-image-list" ref="hiddenImageViewerModal">
                  <img v-for="(img, idx) in current_temp_fabric.image_list" :key="idx" :src="img.url" />
                </div>
                <div class="color-list">
                  <div
                    v-for="(v, k) in current_temp_fabric.color_list"
                    :key="k"
                    :class="{
                      active:
                        current_temp_fabric.color_id === v.color_id,
                    }"
                    class="color-item"
                    @click="choose_color(v)" :title="v.color_name_cn"
                  >
                    <div class="item-top">
                      <span v-if="v.rgb" class="rgb-value" :style="{backgroundColor: v.rgb}" @click.stop="showImageListModal()"></span>
                      <img v-else v-viewer="{ url: 'data-source' }" @click.stop :src="v.color_value | default_img" :data-source="v.color_value" alt="" class="color-img"/>
                      <div class="color-name">{{ v.color_name_cn }}</div>
                    </div>
                    <div class="info-item">
                      <div class="label">C卡色号:</div>
                      <div class="value">{{ v.pantoneC }}</div>
                    </div>
                    <div class="info-item">
                      <div class="label">TCX色号:</div>
                      <div class="value">{{ v.pantoneTcx }}</div>
                    </div>
                    <div class="info-item">
                      <div class="label">TPG色号:</div>
                      <div class="value">{{ v.pantoneTpg }}</div>
                    </div>
                  </div>
                </div>
                <div class="btn-group">
                  <div class="btn btn-cancel" @click="close_color_modal">
                    取消
                  </div>
                  <div class="btn btn-confirm" @click="confirm_color">确定</div>
                </div>
              </div>
            </div>
          </div>
        </template>
        <template v-if="current_tab1 == 'self' && current_tab2 == 's2'">
          <iframe
            sandbox="allow-scripts allow-forms allow-same-origin allow-popups"
            style="width: 100%;height:100%;"
            src="https://s.1688.com/selloffer/offer_search.htm?keywords=%C3%E6%C1%CF&spm=a260k.home2025.searchbox.0"
            frameborder="0"
          ></iframe>
        </template>
        <template v-if="is_show_history">
          <div class="history-team-box">
                  <div v-if="is_show_history" class="my-pattern-menu">
                    <div
                      :class="[
                        'menu-parent-item',
                        { active: current_pattern_menu == 1 },
                      ]"
                      @click="onMenuChange(1)"
                    >
                      <img
                        :src="
                          current_pattern_menu == 1
                            ? require('@/assets/images/team/icon-team-history-active.png')
                            : require('@/assets/images/team/icon-team-history.png')
                        "
                        alt=""
                        class="menu-icon"
                      />我的历史面料
                    </div>
                    <div
                      :class="[
                        'menu-parent-item',
                        { active: current_pattern_menu == 2 },
                      ]"
                      @click="onMenuChange(2)"
                    >
                      <img
                        :src="
                          current_pattern_menu == 2
                            ? require('@/assets/images/team/icon-team-folder-tree-active.png')
                            : require('@/assets/images/team/icon-team-folder-tree.png')
                        "
                        alt=""
                        class="menu-icon"
                      />
                      <div class="label-name">
                        团队资源库<Icon
                          :type="
                            current_pattern_menu == 2
                              ? 'ios-arrow-down'
                              : 'ios-arrow-forward'
                          "
                          size="16"
                        />
                      </div>
                    </div>
                    <ul v-if="current_pattern_menu == 2">
                      <li
                        v-for="(item, index) in team_list"
                        :class="[{ 'active-team': curr_team.id == item.id }]"
                        :key="index"
                        @click="onTeamChoose(item)"
                      >
                        <span>{{ item.name }}</span>
                      </li>
                    </ul>
                  </div>
                  <div style="flex: 1">
                    <template v-if="is_show_history">
                      <div
                        v-if="current_pattern_menu == 1"
                        class="history-tag-box"
                      >
                        <div class="history-tab">
                          <div
                            :class="[
                              'tag-item',
                              { active: current_history_type == -1 },
                            ]"
                            @click="current_history_type = -1"
                          >
                            全部
                          </div>
                          <div
                            :class="[
                              'tag-item',
                              { active: current_history_type == 1 },
                            ]"
                            @click="current_history_type = 1"
                          >
                            平台面料
                          </div>
                          <div
                            :class="[
                              'tag-item',
                              { active: current_history_type == 3 },
                            ]"
                            @click="current_history_type = 3"
                          >
                            自己提供面料
                          </div>
                        </div>
                        <div class="batch-box" v-if="false">
                          <template v-if="batch_mode">
                            <Checkbox>全选</Checkbox>
                            <div class="batch-btn">加入团队资源库</div>
                          </template>
                          <div
                            class="batch-btn"
                            @click="batch_mode = !batch_mode"
                          >
                            {{ batch_mode ? "退出管理" : "批量管理" }}
                          </div>
                        </div>
                      </div>
                      <div class="history-tag-box" v-else>
                        <div
                          :class="[
                            'tag-item-folder',
                            { 'folder-item-active': !curr_second_folder.uuid },
                          ]"
                          @click="
                            onGetTeamFolderFileList(folder_list[0], true, true)
                          "
                        >
                          全部({{ folder_list[0].count }})
                        </div>
                        <div
                          v-for="(item, index) in secondaryList"
                          :key="index"
                          :class="[
                            'tag-item-folder',
                            {
                              'folder-item-active':
                                curr_second_folder.uuid == item.uuid,
                            },
                          ]"
                          @click="onGetTeamFolderFileList(item, true, false)"
                        >
                          {{ item.name }}({{ item.count }})
                        </div>
                        <Icon
                          :type="
                            show_more_folder ? 'ios-arrow-up' : 'ios-arrow-down'
                          "
                          class="cursor"
                          size="16"
                          @click="show_more_folder = !show_more_folder"
                        />
                      </div>
                    </template>
                    <template v-if="!uploading && current_pattern_menu == 1">
                      <table align="center">
                        <thead>
                          <tr>
                            <!-- <th>款号</th> -->
                            <th>面料信息</th>
                            <th>订单信息</th>
                            <th>操作</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr
                            v-for="(item, index) in history_list"
                            :key="index"
                          >
                            <td>
                              <div class="info-box">
                                <img
                                  :src="item.cover_img | default_img"
                                  alt=""
                                  class="cover-img"
                                />
                                <div class="info">
                                  <div class="info-title">
                                    {{ item.name || "-" }}
                                    <span
                                      v-if="item.type"
                                      :class="[
                                        'title-tag',
                                        {
                                          platform: item.type == 1,
                                          custom: item.type == 3,
                                        },
                                      ]"
                                      >[{{
                                        item.type == 1
                                          ? "平台面料"
                                          : "客供面料"
                                      }}]</span
                                    >
                                  </div>
                                  <div class="info-key">
                                    编号:{{ item.key || "-" }}
                                  </div>
                                </div>
                              </div>
                            </td>
                            <td
                              style="
                                display: flex;
                                justify-content: center;
                                width: 100%;
                              "
                            >
                              <div style="text-align: left; width: fit-content">
                                <p><span>订单编号:</span>{{ item.order_no }}</p>
                                <p>
                                  <span>使用款号:</span
                                  >{{ item.style_number || "-" }}
                                </p>
                              </div>
                            </td>
                            <td>
                              <div class="operation-col">
                                <div class="operation">
                                  <div
                                    v-if="!form_data_history.is_self"
                                    class="btn"
                                    @click="open_fabric_detail(item.data)"
                                  >
                                    查看
                                  </div>
                                  <span v-if="!form_data_history.is_self"
                                    >|</span
                                  >
                                  <div
                                    class="btn"
                                    @click="onHistorySelect(item.data)"
                                  >
                                    选择
                                  </div>
                                </div>
                                <div
                                  v-if="!form_data_history.is_self"
                                  class="join-team"
                                  @click="onAddTeamFile(item)"
                                >
                                  加入团队资源库
                                </div>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </template>
                    <div
                      class="team-file"
                      v-else-if="!uploading && current_pattern_menu == 2"
                    >
                      <table>
                        <thead>
                          <tr>
                            <th
                              v-if="current_pattern_menu == 1 && batch_mode"
                              style="width: 16px; height: 16px"
                            ></th>
                            <th style="width: 40%">面料信息</th>
                            <th>面料类型</th>
                            <th>操作</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr
                            v-for="(item, index) in team_pattern_list"
                            :key="index"
                            :class="[
                              'tr-relative',
                              {
                                'tr-active':
                                  form_data.pattern[0] &&
                                  item.id === form_data.pattern[0].id,
                              },
                            ]"
                            @click="open_pattern_detail(item)"
                          >
                            <td>
                              <div class="info-container">
                                <img
                                  :src="
                                    (item.info &&
                                    item.info.image &&
                                    util.test_image(item.info.image)
                                      ? item.info.image
                                      : item.info && item.info.path
                                      ? item.info.path
                                        ? util.get_image_icon(item.info.path)
                                        : ''
                                      : '') | default_img(false)
                                  "
                                  alt=""
                                  class="cover-img"
                                />
                                <div class="item-info">
                                  <div class="title">
                                    <div class="main" :title="item.name">
                                      {{ item.name }}
                                    </div>
                                    <div
                                      :class="[
                                        'sub',
                                        item.fabric && item.fabric.id
                                          ? 'own-pattern'
                                          : 'custom-pattern',
                                      ]"
                                    >
                                      [{{
                                        item.fabric && item.fabric.id
                                          ? "平台面料"
                                          : "客供面料"
                                      }}]
                                    </div>
                                  </div>
                                  <div class="info">
                                    编号:{{ item.info.fabric_key || "-" }}
                                  </div>
                                </div>
                              </div>
                            </td>
                            <td>
                              <div class="style-col">
                                {{ item.file_folder_name || "-" }}
                              </div>
                            </td>
                            <td>
                              <div class="operation-col">
                                <div class="left-operation">
                                    <template v-if="item.fabric && item.fabric.id">
                                        <div
                                            class="btn"
                                            @click.stop="onTeamFileView(item)"
                                        >
                                            查看
                                        </div>
                                        <div class="line">|</div>
                                    </template>
                                  <div
                                    class="btn"
                                    @click.stop="
                                      onTeamFileChoose({
                                        ...item.fabric,
                                        ...item.info,
                                      })
                                    "
                                  >
                                    {{
                                      item.fabric &&
                                      selected_ids.includes(item.fabric.id)
                                        ? "取消"
                                        : "选择"
                                    }}
                                  </div>
                                </div>
                              </div>
                              <img
                                v-if="
                                  item.fabric &&
                                  selected_ids.includes(item.fabric.id)
                                "
                                src="@/assets/images/icon-check.png"
                                alt=""
                                class="selected-icon"
                              />
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                    <template v-else>
                      <Spin fix v-if="uploading">
                        <Icon
                          type="ios-loading"
                          size="40"
                          class="spin-icon-load"
                        ></Icon>
                        <div>数据加载中...</div>
                      </Spin>
                    </template>
                    <div class="page-container">
                      <Page
                        :current="form_data_history.page"
                        v-if="total > 0"
                        :page-size="form_data_history.size"
                        :total="total"
                        @on-change="changeHistoryPage"
                        show-total
                        style="margin-top: 20px"
                      ></Page>
                    </div>
                  </div>
                </div>
        </template>
        <template v-if="current_tab1 === 'daigou'">
          <div class="daigou-content">
            <img
              src="@/assets/images/icon-daigou-introduction.png"
              alt=""
              class="daigou-img"
            />
            <div class="daigou-sub-title">代购面料服务说明</div>
            <p>
              本平台支持全球优质面料代购服务！无论您需要稀缺进口面料、小众设计师面料，还是特定材质
              / 花色面料等,
            </p>
            <p>
              均可在左侧点击添加面料，根据提示填写信息，提交需求，我们专业团队全程对接采购、质检、物流等，
            </p>
            <p>助力您的设计创作无物料顾虑，让您的创意落地无阻碍！</p>
          </div>
        </template>
      </div>
    </div>
    <popup
      :show.sync="is_popup_show_detail"
      height="680px"
      width="980px"
      @on-close="close_fabric_detail"
    >
      <div class="fabric-content-wrap" style="height: 100% !important">
        <div class="info-wrap">
          <div class="left-popup">
            <div
              v-if="
                (current_temp_fabric.image_list &&
                  current_temp_fabric.image_list.length > 0) ||
                current_temp_fabric.video
              "
              class="slider"
            >
              <swiper ref="swiper" :options="swiperOption">
                <swiper-slide v-if="current_temp_fabric.video">
                  <video
                    v-if="current_temp_fabric.video"
                    :src="current_temp_fabric.video"
                    muted
                    autoplay
                    controls
                    id="video-material"
                  >
                    您的浏览器不支持视频播放。
                  </video>
                </swiper-slide>
                <swiper-slide
                  v-for="(item, index) in current_temp_fabric.image_list"
                  :key="`sl` + index"
                >
                  <img v-viewer :src="item.url" class="img" />
                </swiper-slide>
                <!--                                    <div class="swiper-pagination" slot="pagination"></div>-->
                <div slot="button-prev" class="swiper-button-prev"></div>
                <div slot="button-next" class="swiper-button-next"></div>
              </swiper>
            </div>
          </div>
          <div class="right">
            <p class="name">{{ current_temp_fabric.fabric_name_cn }}</p>
            <!-- <p class="no">面料编号：{{ current_temp_fabric.fabric_key }}</p> -->
            <p class="price" v-if="current_temp_fabric.fabric_price>0">
              价格:¥{{ current_temp_fabric.fabric_price
              }}{{
                current_temp_fabric.unit ? "/" + current_temp_fabric.unit : ""
              }}
            </p>
            <p class="price" v-else>咨询客服</p>
            <div
              class="title"
              style="border-top: 1px solid #e0e0e0; margin-bottom: 20px"
            >
              <!-- 面料参数 -->
            </div>
            <div class="list">
              <div class="item">
                <span class="key">货号：</span
                ><span class="value">{{ current_temp_fabric.goods_no || '-' }}</span>
              </div>
              <div class="item">
                <span class="key">分类：</span
                ><span class="value">{{ current_temp_fabric.category_name || '-' }}</span>
              </div>
              <div class="item">
                <span class="key">成分：</span
                ><span class="value">{{ current_temp_fabric.component }}</span>
              </div>
              <div class="item">
                <span class="key">克重：</span
                ><span class="value"
                  >{{ current_temp_fabric.weight
                  }}<template v-if="current_temp_fabric.unit_weight == 2"
                    >G/M<sup>2</sup></template
                  ><template v-if="current_temp_fabric.unit_weight == 1"
                    >G/M</template
                  ></span
                >
              </div>
              <div class="item">
                <span class="key">幅宽：</span
                ><span class="value"
                  >{{ current_temp_fabric.width_wide }} CM</span
                >
              </div>
              <div class="item">
                <span class="key">国标：</span
                ><span class="value">{{ current_temp_fabric.standard }}</span>
              </div>
              <div class="item">
                <span class="key">织物：</span
                ><span class="value">{{ current_temp_fabric.zhiwu || '-' }}</span>
              </div>
              <div class="item">
                <span class="key">面料功能：</span
                ><span class="value">{{ current_temp_fabric.gongneng || '-' }}</span>
              </div>
              <div class="item">
                <span class="key">织法：</span
                ><span class="value">{{ current_temp_fabric.zhifa || '-' }}</span>
              </div>
              <div class="item">
                <span class="key">单位：</span
                ><span class="value">{{ current_temp_fabric.unit }}</span>
              </div>
              <div class="item">
                <span class="key">提供寄样服务：</span
                ><span class="value">{{
                  current_temp_fabric.is_support_send_sample ? "是" : "否"
                }}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="title-box">
          <div class="title">颜色选择</div>
          <div class="line"></div>
        </div>
        <div class="color-box">
          <!-- 隐藏的image_list图片，用于rgb色块点击时查看 -->
          <div v-viewer class="hidden-image-list" ref="hiddenImageViewer">
            <img v-for="(img, idx) in current_temp_fabric.image_list" :key="idx" :src="img.url" />
          </div>
          <div v-for="(item,index) in current_temp_fabric.color_list" :key="index" @click="choose_color(item)" :class="['color-items',{active:current_temp_fabric.color_id === item.color_id}]">
            <div class="item-top">
              <span class="color-img" v-if="item.rgb" :style="{'background-color':item.rgb}" @click.stop="showImageList()"></span>
              <img v-else v-viewer="{ url: 'data-source' }" @click.stop :src="item.color_value | default_img" :data-source="item.color_value" alt="" class="color-img"/>
              <div class="color-name" :title="`${item.color_name_cn}`">{{ item.color_name_cn }}</div>
            </div>
            <div class="info-item">
              <div class="label">C卡色号:</div>
              <div class="value">{{ item.pantoneC }}</div>
            </div>
            <div class="info-item">
              <div class="label">TCX色号:</div>
              <div class="value">{{ item.pantoneTcx }}</div>
            </div>
            <div class="info-item">
              <div class="label">TPG色号:</div>
              <div class="value">{{ item.pantoneTpg }}</div>
            </div>
          </div>
          <!-- <div
            v-for="(item, index) in current_temp_fabric.color_list"
            :key="index"
            @click="choose_color(item)"
            :class="[
              'color-item',
              {
                active:
                  current_temp_fabric.color_name_cn === item.color_name_cn,
              },
            ]" :title="item.color_name_cn"
          >
            <span v-if="item.rgb" :style="{'background-color': item.rgb}" class="color-img"></span>
            <img v-else v-viewer="{ url: 'data-source' }" @click.stop :src="item.color_value | default_img" :data-source="item.color_value" alt="" class="color-img"/>{{ item.color_name_cn }}
          </div> -->
        </div>
        <div class="title-box">
          <div class="title">产品详情</div>
          <div class="line"></div>
        </div>
        <div
          class="richtext-wrap"
          v-html="current_temp_fabric.description"
        ></div>
        <div class="btn-box">
          <button class="cancel-btn" @click="close_fabric_detail">取消</button>
          <button class="confirm-btn" @click="confirm_color_detail">
            确认选择
          </button>
        </div>
      </div>
    </popup>
    <!-- 团队文件夹弹窗 -->
    <move-file
      ref="moveFilePop"
      v-if="show_move_file"
      :file="curr_file"
      :teamId="ownTeam.uuid"
      :teamName="ownTeam.name"
      :rootFolderType="2"
      @on-move-success="onGetTeamFolderFileList"
      @on-close="show_move_file = false"
    />
  </div>
</template>
<script>
import {
  FabricCategoryList,
  FabricLabelList,
  FabricList,
  folderFileCount,
  getDesignHistory,
  GetOwnerMaterialList,
  teamFileListForDesgin,
  teamFolderFileList,
  teamList,
} from "@/api/index.js";
import Popup from "@/components/Popup.vue";
import { uploadFileToOSS } from "@/utils/oss";
import util from "@/utils/util";
import axios from "axios";
import "swiper/dist/css/swiper.css";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import { mapState } from "vuex";
import Lesson from "./Lesson.vue";
import MoveFile from "./MoveFile.vue";
export default {
  name: "Material",
  data() {
    return {
      util: util,
      swiperOption: {
        loop: false, // 循环播放, 可有无限滚动效果，初始加载即是滚动后的效果
        autoplay: false,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
        on: {
          slideChange: function () {
            if (document.getElementById("video-material")) {
              if (this.activeIndex === 0) {
                document.getElementById("video-material").play();
              } else {
                document.getElementById("video-material").pause();
              }
            }
          },
        },
        observer: true, //修改swiper自己或子元素时，自动初始化swiper
        observeParents: true, //修改swiper的父元素时，自动初始化swiper
      },
      upload_url: process.uniEnv.BASE_API + "/util/upload-image",
      form_data_fabric: {
        page: 1,
        size: 20,
        keyword: "",
        fabric_category_id: 0,
        type: 1,
      },
      form_data_history: {
        page: 1,
        size: 20,
        keyword: "",
        type: "fabric",
        is_self: false,
        is_all: true,
      },
      total: -1,
      fabric_label_list: [],
      fabric_label_ids: [],
      sub_fabric_category_list: [],
      fabric_category_list: [],
      fabric_list: [],
      history_list: [],
      current_history_type: -1,
      current_fabric_category_id: 0,
      current_sub_fabric_category_id: 0,
      current_temp_fabric: {
        image_list: [],
      },
      is_popup_show_detail: false,
      is_color_show: false,
      current_tab1: "default",
      width: "600px",
      is1688: false,
      current_tab2: "s1",
      publish_time_list: [
        { name: "3个月", value: "3" },
        { name: "6个月", value: "6" },
        { name: "9个月", value: "9" },
        { name: "1年", value: "12" },
        { name: "1年以上", value: "12+" },
      ],
      publish_time_selected: [],
      is_show_history: false,
      uploading: false,
      current_pattern_menu: 1,
      team_list: [],
      curr_team: {},
      folder_list: [],
      show_move_file: false,
      curr_file: {},
      secondary_folder_list: [],
      curr_second_folder: {},
      team_file_list: [],
      show_more_folder: false,
      team_pattern_list: [],
      batch_mode: false,
      is_show_wear_house: false,
      wear_tabs: [
        { name: "全部面料", value: "all", status: 99 },
        {
          name: "未入仓",
          value: "un-in",
          status: 0,
          has_count: true,
          count: 0,
        },
        { name: "已入仓", value: "in", status: 1, has_count: true, count: 0 },
      ],
      query_wear_house: {
        type: "1",
        keyword: "",
        page: 1,
        limit: 10,
        status: 99,
      },
      wh_list: [],
      is_loading:false,
      // uploading: false,
      uploadQueue:[],
      debounceTimer: null, // 防抖定时器
      debounceTime: 300, // 防抖时间（毫秒）
      show_all_cate:false
    };
  },
  filters:{
    body_title_filter(tab1,tab2,is_show_history){
      if(is_show_history){
        return '面料使用记录'
      }
      switch(tab1){
        case 'daigou':
          return '平台代购面料服务';
        case 'self':
          if(tab2 == 's2'){
            return '面料选择';
          }
          return '我的面料'
        default:
          return '面料选择';
      }
    }
  },
  components: {
    Popup,
    swiper,
    swiperSlide,
    Lesson,
    MoveFile,
  },
  watch: {
    "form_data.parent_product_category_id": {
      handler(newVal, oldVal) {
        if (newVal > 0) {
          let cate = this.fabric_category_list.find(
            (v) => v.product_category_id === newVal
          );
          if (cate) {
            this.choose_fabric_category(cate);
          }
        }
      },
      immediate: true, // 立即执行一次handler以初始化数据
      deep: true, // 深度监听（虽然在这个场景下可能不是必需的）
    },
    current_history_type(news, olds) {
      this.form_data_history.is_self = news == 3;
      this.form_data_history.is_all = news == -1;
      this.searchHistory(true);
    },
    is_show_wear_house(news, olds) {
      if (news) {
        this.onGetWearHouseList();
      }
    },
  },
  computed: {
    ...mapState({
      form_data: (state) => state.design.form_data,
      height: (state) => state.design.height,
      is_lesson_show: (state) => state.design.is_lesson_show,
      product_category_list: (state) => state.design.product_category_list,
    }),
    selected_ids() {
      return this.form_data.material.map((v) => v.id);
    },
    hasOwnTeam() {
      const { team_list } = this;
      return team_list.filter((item) => item.role === "所有者").length > 0;
    },
    folderList() {
      return this.folder_list.filter((item) => item.is_dir);
    },
    fileList() {
      return this.folder_list.filter((item) => !item.is_dir);
    },
    ownTeam() {
      const { team_list } = this;
      return team_list.find((item) => item.role === "所有者");
    },
    secondaryList() {
      if (this.show_more_folder) {
        return this.secondary_folder_list;
      } else {
        return this.secondary_folder_list.slice(0, 5);
      }
    },
  },
  methods: {
    onDelImg(k, i) {
      const list = this.form_data.material_daigou;
      if (!list || !list[k] || !list[k].image_list) return;

      const currentObj = list[k];
      const imgList = currentObj.image_list;

      if (i < 0 || i >= imgList.length) return;

      imgList.splice(i, 1);
      let newIndex = currentObj.currentImageIndex || 0;

      if (imgList.length === 0) {
        newIndex = 0;
      } else {
        if (i <= newIndex) {
          newIndex = Math.max(0, newIndex - 1);
        }

        if (newIndex >= imgList.length) {
          newIndex = imgList.length - 1;
        }
      }

      this.$set(currentObj, 'currentImageIndex', newIndex);

      if (imgList.length > 0) {
        currentObj.image = imgList[0];
      } else {
        currentObj.image = "";
      }

      this.$store.commit("design/arr_update_one", {
        key: "material_daigou",
        index: k,
        value: { ...currentObj },
      });
    },
    switchImage(k, direction) {
      const list = this.form_data.material_daigou;
      if (!list || !list[k]) return;

      const item = list[k];
      if (!item.image_list || item.image_list.length <= 1) return;

      let currentIndex = Number(item.currentImageIndex) || 0;
      const total = item.image_list.length;

      let newIndex;
      if (direction === 'left') {
        newIndex = (currentIndex - 1 + total) % total;
      } else {
        newIndex = (currentIndex + 1) % total;
      }

      this.$set(item, 'currentImageIndex', newIndex);

      this.$set(item, 'image', item.image_list[newIndex]);

      this.$forceUpdate();
    },
    onWhItemBuild(material) {
      const { name, no, image, wide_width, weight, component, color } =
        material;
      const new_material = {
        fabric_price: "-",
        unit: "-",
        description: "-",
        unit_weight: "-",
        is_support_send_sample: false,
        color_name_cn: "",
        color_value: "",
        color_key: "",
        fabric_name_cn: name,
        fabric_key: no,
        image,
        image_list: [image],
        width_wide: wide_width,
        component,
        weight,
        color_list: color.map((item) => {
          return {
            color_name_cn: item.name,
            color_value: item.image,
            color_key: item.uuid,
            color_id: item.uuid,
          };
        }),
      };
      return new_material;
      // this.current_temp_fabric = new_material;
    },
    onChooseWhItem(material) {
      this.current_temp_fabric = this.onWhItemBuild(material);
      console.log("temp__fabric", this.current_temp_fabric);
      this.is_color_show = true;
    },
    onWhDetailClick(material) {
      console.log("material", material);
      this.current_temp_fabric = this.onWhItemBuild(material);
      this.is_popup_show_detail = true;
    },
    async onGetWearHouseList() {
      try {
        this.is_loading = true;
        const { code, msg, data } = await GetOwnerMaterialList({
          ...this.query_wear_house,
        });
        if (code > 0) {
          this.$layer.msg(msg);
          return;
        }
        console.log("data--wearhouse", data);
        if (data.list.length) {
          this.wh_list = data.list;
        }
        this.total = data.count;
      } catch (e) {
        console.log("err-wear-house-list", e);
        this.$layer.msg(e.msg);
      }finally{
        this.is_loading = false;
      }
    },
    onWhTabClick({ value }) {
      switch (value) {
        case "un-in":
          this.query_wear_house.status = 0;
          break;
        case "in":
          this.query_wear_house.status = 1;
          break;
        default:
          this.query_wear_house.status = 99;
          break;
      }
      this.onGetWearHouseList();
      // this.query_wear_house.type=value;
    },
    async onGetFileCount() {
      try {
        // folderFileCount
        const { curr_team, folderList } = this;
        const param = {};
        param.team_uuid = curr_team.uuid;
        param.folder_uuid = folderList[0].uuid;
        // console.log('param-count===>',param);
        const { code, msg, data } = await folderFileCount(param);
        if (code > 0) {
          this.$layer.msg(msg);
          return;
        }
        // console.log('data-count===>',data);
        const countMap = {};
        data.forEach((item) => {
          const [id, count] = Object.entries(item)[0];
          countMap[Number(id)] = count;
        });

        this.folder_list[0].count = countMap[this.folder_list[0].id] || 0;

        // 更新 secondary_folder_list 中每个项目的 count 值
        this.secondary_folder_list = this.secondary_folder_list.map((item) => {
          const count = countMap[item.id] || 0;
          return {
            ...item,
            count: count,
          };
        });

        // console.log('updated secondary_folder_list:', this.secondary_folder_list);
      } catch (e) {
        console.log("err-get-file-count", e);
        this.$layer.msg(e.msg || JSON.stringify(e));
      }
    },
    async onGetTeamFileForDesign(is_all = false) {
      try {
        this.is_loading = true;
        const { curr_second_folder, curr_team, folderList, form_data_history } =
          this;
        const { page, size, keyword } = form_data_history;
        const param = {};
        param.page = page;
        param.size = size;
        param.keyword = keyword;
        param.team_uuid = curr_team.uuid;
        param.folder_uuid = is_all
          ? folderList[0].uuid
          : curr_second_folder.uuid || folderList[0].uuid;
        const { code, msg, data } = await teamFileListForDesgin(param);
        if (code > 0) {
          this.$layer.msg(msg);
          return;
        }
        console.log("data", data);
        this.team_pattern_list = data.list;
        this.total = data.count;
      } catch (e) {
        console.log("err-get-team-file-list-design", e);
        this.$layer.msg(e.msg || JSON.stringify(e));
      }finally{
        this.is_loading = false;
      }
    },
    onAddTeamFile(file) {
      console.log("material-file", file);
      this.curr_file = file;
      this.show_move_file = true;
    },
    async onTeamChoose(team) {
      if (!team) return;
      this.curr_team = team;
      await this.onGetTeamFolderFileList();
      await this.onGetTeamFolderFileList(this.folder_list[0], false, true);
      await this.onGetTeamFolderFileList(
        this.secondary_folder_list[0],
        true,
        true
      );
      await this.onGetFileCount();
      await this.onGetTeamFileForDesign();
    },
    async onGetTeamFolderFileList(
      folder = {},
      is_file = false,
      is_all = false
    ) {
      try {
        if (!this.curr_team) return;
        if (!is_all) {
          this.curr_second_folder = folder;
        } else {
          this.curr_second_folder = {};
        }
        if (is_file) {
          this.onGetTeamFileForDesign(false);
        }
        const param = {};
        param.team_uuid = this.curr_team.uuid;
        param.parent_directory_uuid = folder.uuid || "";
        const { code, msg, data } = await teamFolderFileList(param);
        if (code > 0) {
          this.$layer.msg(msg);
          return;
        }
        if (!folder || !folder.uuid) {
          this.folder_list = data.filter((item) => item.type == 2);
        } else {
          if (!is_file) {
            this.secondary_folder_list = data.filter((item) => item.is_dir);
          }
        }
      } catch (e) {
        console.log("err-get-file-folder-list", e);
        this.$layer.msg(e.msg || JSON.stringify(e));
      }
    },
    async onGetTeamList() {
      try {
        const { code, msg, data } = await teamList();
        if (code > 0) {
          this.$layer.msg(msg);
          return;
        }
        console.log("data-team-list", data);
        if (!data.length) {
          this.team_list = [];
          this.curr_team = {};
          return;
        }
        this.team_list = data;
        let curr_team = data.filter((item) => item.role === "所有者")[0];
        if (!curr_team) {
          curr_team = data[0];
        }
        this.curr_team = curr_team;
      } catch (e) {
        console.log("err-team-list", e);
        this.$layer.msg(e.msg || JSON.stringify(e));
      }
    },
    async onMenuChange(type) {
      if (type == 1) {
        this.searchHistory(false);
      } else {
        await this.onGetTeamList();
        if (!this.team_list.length) {
          this.$layer.msg("您还未加入任何团队，请先创建或加入团队");
          return;
        }
        await this.onGetTeamFolderFileList();
        await this.onGetTeamFolderFileList(this.folder_list[0], false, true);
        await this.onGetTeamFolderFileList(
          this.secondary_folder_list[0],
          true,
          true
        );
        await this.onGetFileCount();
        await this.onGetTeamFileForDesign();
      }
      this.current_pattern_menu = type;
    },
    async onTeamFileChoose(data) {
      console.log("team-file-choose-material", data);
      console.log("onTeamFileChoose 数据的所有字段:", Object.keys(data));
      
      if (!data.relate_id) {
        if (
          this.form_data.material.length +
            this.form_data.material_self.length >=
          10
        ) {
          this.$layer.msg(`最多可添加10种面料`);
          return;
        }
        
        // 处理有 info 对象的情况
        let target_data = data;
        if (data.info) {
          console.log("检测到 data.info 对象，使用 info 里的数据");
          target_data = data.info;
        }
        
        // 尝试多种可能的图片字段名
        let fabric_image = target_data.cover_img || "";
        if (!fabric_image && target_data.image) {
          fabric_image = target_data.image;
        }
        if (!fabric_image && target_data.path) {
          fabric_image = target_data.path;
        }
        if (!fabric_image && target_data.cover) {
          fabric_image = target_data.cover;
        }
        if (!fabric_image && target_data.img) {
          fabric_image = target_data.img;
        }
        if (!fabric_image && target_data.img_url) {
          fabric_image = target_data.img_url;
        }
        if (!fabric_image && target_data.image_url) {
          fabric_image = target_data.image_url;
        }
        if (!fabric_image && target_data.image_list && target_data.image_list[0]) {
          fabric_image = target_data.image_list[0].url || target_data.image_list[0].src || target_data.image_list[0];
        }
        if (!fabric_image && target_data.images && target_data.images[0]) {
          fabric_image = target_data.images[0].url || target_data.images[0].src || target_data.images[0];
        }
        
        console.log("onTeamFileChoose 最终使用的图片:", fabric_image);
        
        this.current_tab2 = "s1";
        let object = {
          alias: target_data.fabric_alias || target_data.alias || "",
          image: fabric_image,
          fabric_key: target_data.fabric_key || target_data.key || "",
          fabric_name_cn: target_data.fabric_name_cn || target_data.name || "",
          width_wide: target_data.width_wide || 0,
          component: target_data.component || "",
          desc: target_data.desc || target_data.description || "",
          color_name: target_data.color_name_cn || target_data.color_name || "",
          weight: target_data.weight || "",
        };
        
        console.log("onTeamFileChoose 最终构建的客供面料对象:", object);
        
        this.$store.commit("design/arr_push_one", {
          key: "material_self",
          value: object,
        });
        this.change_tab1("self");
        this.change_tab2("s1");
      } else {
        console.log("onteamfilechoose", data);
        this.toggle_material(data);
      }
    },
    onTeamFileView(data) {
      if (data.fabric) {
        this.open_fabric_detail(data.fabric);
      }
    },
    onHistorySelect(data) {
      console.log('data--->material',data);
      const { form_data_history } = this;
      const { is_self } = form_data_history;
      if (is_self) {
        if (
          this.form_data.material.length +
            this.form_data.material_self.length >=
          10
        ) {
          this.$layer.msg(`最多可添加10种面料`);
          return;
        }
        if(data.type == 1){
          this.toggle_material(data);
          return;
        }
        this.current_tab2 = "s1";
        let object = {
          alias: data.fabric_alias || "",
          image: data.cover_img,
          fabric_key: data.key || "",
          fabric_name_cn: data.name || "",
          width_wide: data.width_wide || 0,
          component: data.component || "",
          desc: data.desc || "",
        };
        this.$store.commit("design/arr_push_one", {
          key: "material_self",
          value: object,
        });
      } else {
        console.log('data',data);
        this.toggle_material(data);
      }
    },
    onShowHistory() {
      const { current_tab1,current_tab2 } = this;
      if(current_tab2 == 's2'){
        this.change_tab2('s1');
      }
      if (current_tab1 === "self") {
        this.form_data_history.is_self = true;
      } else {
        this.form_data_history.is_self = false;
      }
      if (this.is_lesson_show) this.$store.commit("design/hide_lesson");
      this.form_data_history.page = 1;
      this.is_show_history = true;
      this.searchHistory();
    },
    changeWhPage(page) {
      this.query_wear_house.page = page;
      this.onGetWearHouseList();
    },
    changeHistoryPage(page) {
      // console.log('changeHistoryPage',e);
      console.log("this.form_data_history", this.form_data_history);
      this.form_data_history.page = page;
      this.searchHistory();
    },
    async searchHistory(is_search = false) {
      console.log("searchHistory", this.form_data_history.keyword);
      if (is_search) {
        this.form_data_history.page = 1;
      }
      try {
        this.is_loading = true;
        this.uploading = true;
        const { data } = await getDesignHistory({ ...this.form_data_history });
        console.log("data-history", data);
        this.total = data.total;
        console.log("total===>history", this.total);
        this.history_list = data.list;
        this.uploading = false;
      } catch (e) {
        console.log("err-history", e);
        this.uploading = false;
      }finally{
        this.is_loading = false;
      }
    },
    choose_publish_time(data) {
      if (this.publish_time_selected.includes(data.value)) {
        this.publish_time_selected = this.publish_time_selected.filter(
          (item) => {
            return item !== data.value;
          }
        );
      } else {
        this.publish_time_selected.push(data.value);
      }
      this.getFabricList();
    },
    change_tab2(c) {
      this.current_tab2 = c;
      this.is1688 = c === "s2";
      if (this.is_show_wear_house) {
        this.is_show_wear_house = false;
      }
      console.log("tab-222", c);
      if (c === "s1") {
        if (this.is_show_history) {
          return;
        }
        console.log("自己寄出面料.展示列表");
        if(this.current_tab1 === 'self'){
          this.is_show_wear_house = true;
        }else{
          this.is_show_wear_house = false;
        }
        // this.$store.commit("design/show_lesson");
      } else {
        this.$store.commit("design/hide_lesson");
      }
    },
    change_tab1(c) {
      this.current_tab1 = c;
      if (this.is_show_history) {
        this.is_show_history = false;
      }
      if (this.is_show_wear_house) this.is_show_wear_house = false;
      this.reset_temp_fabric();
      if (c === "default") {
        this.change_tab2('s1');
        this.$store.commit("design/hide_lesson");
      } else {
        // console.log('is_self',c);
        if(c === 'daigou'){
          this.change_tab2('s1');
          return;
        }
        this.change_tab2("s2");
      }
    },
    choose_fabric_type(type) {
      this.form_data_fabric.type = type;
      this.getFabricList();
    },
    onBeforeUpload(file, k) {
      uploadFileToOSS(file, "template").then((res) => {
        let object = this.form_data.material_self[k];
        object.image = res;
        this.$store.commit("design/arr_update_one", {
          key: "material_self",
          index: k,
          value: object,
        });
      });
      return false;
    },
    async processAllFiles(k) {
      const queue = [...this.uploadQueue];
      this.uploadQueue = []; // 清空队列

      console.log(`Startting upload ${queue.length} files...`);

      const newUrls = [];

      for (const file of queue) {
          try {
            const url = await uploadFileToOSS(file, "template");
            newUrls.push(url);
          } catch (err) {
            this.$layer.msg(`上传失败==>：${file.name}`);
          }
      }

      if(!newUrls.length) return;
      console.log('urls---<',newUrls);
      const currentList = this.form_data.material_daigou;
      if(!currentList || !currentList[k]) return;
      const currentItem = currentList[k];
      console.log('currentItem',currentItem);
      const updatedItem = {
        ...currentItem,image_list:[...(currentItem.image_list || []),...Array.from(new Set(newUrls))]
      }
      if (typeof updatedItem.currentImageIndex === 'undefined' || updatedItem.currentImageIndex === null) {
        updatedItem.currentImageIndex = 0;
      }

      console.log('updated_item',updatedItem);
      if (updatedItem.image_list.length > 0) {
        updatedItem.image = updatedItem.image_list[0];
      } else {
        updatedItem.image = "";
      }

      console.log('updated_item->image',updatedItem);

      this.$store.commit("design/arr_update_one", {
        key: "material_daigou",
        index: k,
        value: updatedItem,
      });

    },
    onBeforeUpload2(file, k) {

      this.uploading = true;
      // 将文件加入队列
      this.uploadQueue.push(file);

      // 清除旧定时器
      if (this.debounceTimer) {
          clearTimeout(this.debounceTimer);
      }

      // 设置新定时器：如果一段时间内没有新文件进来，则认为上传完成
      this.debounceTimer = setTimeout(() => {
          this.processAllFiles(k);
      }, this.debounceTime);
      return false;
    },
    onBeforeUpload3(file) {
      if (this.form_data.material_file.length >= 10) {
        this.$layer.msg(`最多可添加10个文件`);
        return;
      }
      uploadFileToOSS(file, "template").then((url) => {
        let object = { name: file.name, path: url };
        this.$store.commit("design/arr_push_one", {
          key: "material_file",
          value: object,
        });
      });
      return false;
    },
    del_material_file(k) {
      this.$store.commit("design/arr_remove_one", {
        key: "material_file",
        index: k,
      });
    },
    choose_label(v) {
      if (this.fabric_label_ids.includes(v.id)) {
        this.fabric_label_ids = this.fabric_label_ids.filter((item) => {
          return item !== v.id;
        });
      } else {
        this.fabric_label_ids.push(v.id);
        this.fabric_label_ids = [...new Set(this.fabric_label_ids)];
      }
      this.form_data_fabric.page = 1;
      this.getFabricList();
    },
    del_material(k) {
      this.$DModal.confirm({
        content: "是否取消已选数据？",
        onOK: async () => {
          this.$store.commit("design/arr_remove_one", {
            key: "material",
            index: k,
          });
        },
      });
    },
    toggle_material(v) {
      console.log("toggle_material", v);
      if (this.selected_ids.includes(v.id)) {
        let idx = this.form_data.material.findIndex((obj) => obj.id === v.id);
        this.del_material(idx);
      } else {
        console.log("open_color_modal", v);
        this.open_color_modal(v);
      }
    },
    open_color_modal(fabric) {
      this.current_temp_fabric = Object.assign({}, fabric);
      // if (this.current_temp_fabric.color_list.length > 1) {
      //     console.log('aaa');
      //     this.is_color_show = true;
      // } else {
      //     console.log('current_temp_fabric',this.current_temp_fabric.color_list);
      //     this.choose_color(this.current_temp_fabric.color_list[0])
      //     this.confirm_color()
      // }
      if (
        this.current_temp_fabric.color_list &&
        this.current_temp_fabric.color_list.length > 1
      ) {
        console.log("aaa");
        this.is_color_show = true;
      } else {
        this.is_color_show = false;
        if (
          this.current_temp_fabric.color_list &&
          this.current_temp_fabric.color_list.length > 0
        ) {
          console.log(
            "current_temp_fabric",
            this.current_temp_fabric.color_list
          );
          this.choose_color(this.current_temp_fabric.color_list[0]);
          this.confirm_color();
        }
      }
    },
    choose_color(v) {
      console.log("choose_color", v);
      this.$set(this.current_temp_fabric, "color_name_cn", v.color_name_cn);
      this.$set(this.current_temp_fabric, "color_value", v.color_value);
      this.$set(this.current_temp_fabric, "color_rgb", v.rgb);
      this.$set(this.current_temp_fabric, "color_key", v.color_key);
      this.$set(this.current_temp_fabric,"color_id",v.color_id);
    },
    showImageList() {
      this.$nextTick(() => {
        const viewer = this.$refs.hiddenImageViewer;
        if (viewer && viewer.$viewer) {
          viewer.$viewer.show();
        }
      });
    },
    showImageListModal() {
      this.$nextTick(() => {
        const viewer = this.$refs.hiddenImageViewerModal;
        if (viewer && viewer.$viewer) {
          viewer.$viewer.show();
        }
      });
    },
    confirm_color() {
      if (
        this.form_data.material.length + this.form_data.material_self.length >=
        10
      ) {
        this.$layer.msg(`最多可添加10种面料`);
        return;
      }
      let object = { ...this.current_temp_fabric, desc: "", alias: "" };
      console.log('show-wh',this.is_show_wear_house);
      if (this.is_show_wear_house && !this.is_show_history) {
        console.log('is_shoooooo');
        this.add_material_self();
        this.is_color_show = false;
        return;
      }
      this.$store.commit("design/arr_push_one", {
        key: "material",
        value: object,
      });
      this.is_color_show = false;
      this.reset_temp_fabric();
    },
    confirm_color_detail() {
      if (
        this.form_data.material.length + this.form_data.material_self.length >=
        10
      ) {
        this.$layer.msg(`最多可添加10种面料`);
        return;
      }
      let object = { ...this.current_temp_fabric, desc: "", alias: "" };
      console.log("object-->on->confirm_color_detail", object);
      console.log('is_show_wh',this.is_show_wear_house);
      if (this.is_show_wear_house) {
        this.add_material_self();
        return;
      }
      this.$store.commit("design/arr_push_one", {
        key: "material",
        value: object,
      });
      this.is_popup_show_detail = false;
      this.reset_temp_fabric();
    },
    close_color_modal() {
      this.is_color_show = false;
      this.reset_temp_fabric();
    },
    
    // 处理从 localStorage 读取的面料数据
    processSelectedFabric(fabric) {
      console.log("processSelectedFabric", fabric);
      
      // 判断面料类型并处理
      if (fabric.id) {
        // 平台面料（有 id 字段）
        this.processPlatformFabric(fabric);
      } else if (fabric.info) {
        // 团队面料（有 info 字段）
        this.processTeamFabric(fabric);
      } else {
        // 从详情页跳转的面料
        this.processCustomFabric(fabric);
      }
    },
    
    // 处理平台面料
    processPlatformFabric(fabric) {
      this.toggle_material(fabric);
    },
    
    // 处理团队面料
    processTeamFabric(fabric) {
      // 直接使用团队面料的数据结构
      this.onTeamFileChoose(fabric);
    },
    
    // 处理自定义面料（从详情页跳转）
    processCustomFabric(fabric) {
      console.log("处理自定义面料:", fabric);
      console.log("面料数据的所有字段:", Object.keys(fabric));
      
      // 先处理有 info 对象的情况
      let target_fabric = fabric;
      if (fabric.info) {
        console.log("检测到 fabric.info 对象，使用 info 里的数据");
        target_fabric = fabric.info;
      }
      
      console.log("目标面料数据:", target_fabric);
      console.log("目标面料数据的所有字段:", Object.keys(target_fabric));
      
      console.log("尝试查找图片字段:", {
        image: target_fabric.image,
        path: target_fabric.path,
        cover_img: target_fabric.cover_img,
        cover: target_fabric.cover,
        image_list: target_fabric.image_list,
        images: target_fabric.images,
        img: target_fabric.img,
        img_url: target_fabric.img_url,
        image_url: target_fabric.image_url,
      });
      
      // 从详情页跳转过来的面料，直接添加到客供面料中
      if (
        this.form_data.material.length + this.form_data.material_self.length >= 10
      ) {
        this.$layer.msg(`最多可添加10种面料`);
        return;
      }
      
      // 尝试多种可能的图片字段名
      let fabric_image = target_fabric.image || "";
      if (!fabric_image && target_fabric.path) {
        fabric_image = target_fabric.path;
      }
      if (!fabric_image && target_fabric.cover_img) {
        fabric_image = target_fabric.cover_img;
      }
      if (!fabric_image && target_fabric.cover) {
        fabric_image = target_fabric.cover;
      }
      if (!fabric_image && target_fabric.img) {
        fabric_image = target_fabric.img;
      }
      if (!fabric_image && target_fabric.img_url) {
        fabric_image = target_fabric.img_url;
      }
      if (!fabric_image && target_fabric.image_url) {
        fabric_image = target_fabric.image_url;
      }
      if (!fabric_image && target_fabric.image_list && target_fabric.image_list[0]) {
        fabric_image = target_fabric.image_list[0].url || target_fabric.image_list[0].src || target_fabric.image_list[0];
      }
      if (!fabric_image && target_fabric.images && target_fabric.images[0]) {
        fabric_image = target_fabric.images[0].url || target_fabric.images[0].src || target_fabric.images[0];
      }
      
      console.log("最终使用的图片:", fabric_image);
      
      // 构建客供面料对象，确保图片正确传递
      let object = {
        alias: target_fabric.fabric_alias || target_fabric.alias || "",
        image: fabric_image,
        fabric_key: target_fabric.fabric_key || target_fabric.key || "",
        fabric_name_cn: target_fabric.fabric_name_cn || target_fabric.name || "客供面料",
        width_wide: target_fabric.width_wide || 0,
        component: target_fabric.component || "",
        desc: target_fabric.desc || target_fabric.description || "",
        color_name: target_fabric.color_name_cn || target_fabric.color_name || "",
        weight: target_fabric.weight || "",
      };
      
      console.log("最终构建的客供面料对象:", object);
      
      // 添加到客供面料
      this.$store.commit("design/arr_push_one", {
        key: "material_self",
        value: object,
      });
      
      // 切换到客供面料标签页
      this.change_tab1("self");
      this.change_tab2("s1");
    },
    add_material_self() {
      console.error('add_material_self CALLED');
      console.trace(); // <--- 打印调用栈，看清是谁调用了它
      if (
        this.form_data.material.length +
          this.form_data.material_self.length +
          this.form_data.material_daigou.length >=
        10
      ) {
        this.$layer.msg(`最多可添加10种面料`);
        return;
      }
      let object = {
        alias: "",
        image: "",
        fabric_key: "",
        fabric_name_cn: "客供面料",
        width_wide: "",
        component: "",
        desc: "",
        color_name: "",
        weight: "",
      };
      if (this.is_show_wear_house && this.current_temp_fabric) {
        object = {
          ...this.current_temp_fabric,
          color_name: this.current_temp_fabric.color_name_cn,
        };
      }
      this.$store.commit("design/arr_push_one", {
        key: "material_self",
        value: object,
      });
    },
    del_material_self(k) {
      this.$store.commit("design/arr_remove_one", {
        key: "material_self",
        index: k,
      });
    },
    add_material_daigou() {
      if (
        this.form_data.material.length +
          this.form_data.material_self.length +
          this.form_data.material_daigou.length >=
        10
      ) {
        this.$layer.msg(`最多可添加10种面料`);
        return;
      }
      let object = {
        alias: "",
        image: "",
        fabric_key: "",
        fabric_name_cn: "代购面料",
        width_wide: "",
        component: "",
        desc: "",
        color_name: "",
        weight: "",
      };
      this.$store.commit("design/arr_push_one", {
        key: "material_daigou",
        value: object,
      });
    },
    del_material_daigou(k) {
      this.$store.commit("design/arr_remove_one", {
        key: "material_daigou",
        index: k,
      });
    },
    open_fabric_detail(v) {
      this.current_temp_fabric = v;
      if (this.current_temp_fabric.color_list.length === 1) {
        this.choose_color(this.current_temp_fabric.color_list[0]);
      }
      this.is_popup_show_detail = true;
    },
    close_fabric_detail() {
      this.reset_temp_fabric();
      this.is_popup_show_detail = false;
    },
    reset_temp_fabric() {
      this.current_temp_fabric = { image_list: [] };
    },
    changePage(page) {
      this.form_data_fabric.page = page;
      this.getFabricList();
    },
    search_fabric() {
      if(this.is_show_history){
        this.form_data_history.keyword = this.form_data_fabric.keyword;
        this.searchHistory(true);
        return;
      }
      this.getFabricList();
    },
    choose_fabric_category(category) {
      this.current_fabric_category_id =
        this.form_data_fabric.fabric_category_id = category.fabric_category_id;
      if (category.fabric_category_id === 0) {
        this.sub_fabric_category_list = [];
      } else {
        this.sub_fabric_category_list = category.children;
      }
      this.current_sub_fabric_category_id = 0;
      this.form_data_fabric.page = 1;
      this.getFabricList();
    },
    choose_sub_fabric_category(category) {
      this.current_sub_fabric_category_id =
        this.form_data_fabric.fabric_category_id = category.fabric_category_id;
      this.form_data_fabric.page = 1;
      this.getFabricList();
    },
    async getFabricCategoryList() {
        this.is_loading = true;
      return FabricCategoryList().then((response) => {
        this.fabric_category_list = [
          { category_name: "全部", fabric_category_id: 0 },
          ...response.data,
        ];
        this.is_loading = false;
        return response;
      });
    },
    async getFabricLabelList() {
      return FabricLabelList().then((response) => {
        this.fabric_label_list = [...response.data];
        return response;
      });
    },
    async getFabricList() {
        this.is_loading = true;
      const param = {
        ...this.form_data_fabric,
        label_id: this.fabric_label_ids,
      };
      if (this.publish_time_selected.length > 0) {
        param.publish_range = this.publish_time_selected;
      }
      return FabricList(param).then((response) => {
        this.fabric_list = response.data.list;
        this.total = response.data.total;
        this.is_loading = false;
        return response;
      });
    },
    async input2($event, field, k, child_field) {
      const newValue = $event.target.value;
      const originalItem = JSON.parse(JSON.stringify(this.form_data[field][k]));
      let updatedItem;
      // 创建一个全新对象，防止引用污染
      if (child_field === "alias") {
        updatedItem = { ...originalItem, alias: newValue };
      } else {
        updatedItem = {
          ...originalItem,
          [child_field]: newValue,
        };
      }
      await this.$store.commit("design/arr_update_one", {
        key: field,
        index: k,
        value: updatedItem,
      });
    },
    change3($event, field, k, child_field) {
      let object = this.form_data[field][k];
      let o = object.color_list.find((v) => v.color_key == $event.target.value);
      if (o) {
        object[child_field] = $event.target.value;
        object[`color_name_cn`] = o.color_name_cn;
        object[`color_value`] = o.color_value;
      }
      this.$store.commit("design/arr_update_one", {
        key: field,
        index: k,
        value: object,
      });
    },
  },
  mounted() {
    this.width = window.innerWidth - 220 - 490 - 30 + "px";
    axios
      .all([
        this.getFabricCategoryList(),
        this.getFabricLabelList(),
        this.searchHistory(),
        this.onGetTeamList(),
      ])
      .then(
        axios.spread(() => {
          this.getFabricList();
        })
      )
      .then(async () => {
        // 先检查 localStorage 中是否有选中的面料
        const selectedFabricStr = localStorage.getItem('selected_fabric');
        if (selectedFabricStr) {
          const selectedFabric = JSON.parse(selectedFabricStr);
          console.log("从 localStorage 读取到面料:", selectedFabric);
          
          // 清除 localStorage
          localStorage.removeItem('selected_fabric');
          
          // 处理面料数据
          this.processSelectedFabric(selectedFabric);
        } else if (this.team_list.length && this.curr_team.uuid) {
          // 处理路由参数中的文件
          const { file } = this.$route.params;
          console.log("file-mounted", file);
          const processedKey = 'material_file_processed_' + (file?.uuid || '');
          if (file && file.type == "52" && !sessionStorage.getItem(processedKey)) {
            this.is_show_history = true;
            await this.onMenuChange(2);
            const curr_file = file;
            console.log('curr_file',curr_file);
            await this.onTeamFileChoose(curr_file);
            // 标记已处理，避免组件重新创建时重复添加
            sessionStorage.setItem(processedKey, '1');
          }
        }
      });
  },
};
</script>
<style lang="scss" scoped>
.material {
  width: 100%;
  height: 100%;
  display: flex;
  column-gap: 10px;
  .main-form {
    // width: 488px;
    flex: 0 1 488px;
    min-width: 410px; // 防止过度收缩导致无法操作
    max-width: 488px; // 限制最大宽度，保持原有视觉比例
    height: 100%;
    overflow-y: auto;
    padding: 30px;
    background: #fff;
    border-right: 1px solid #f0f0f0;
    &::-webkit-scrollbar {
      display: none;
    }
    .top-tabs {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding-bottom: 15px;
      border-bottom: 1px solid #e0e0e0;
      margin-bottom: 20px;
      column-gap:10px;
      .tab-list {
        display: flex;
        align-items: center;
        column-gap: 10px;
        .tab-item {
          color: #4d4d4d;
          font-size: 16px;
          cursor: pointer;
          white-space:nowrap;
          text-overflow:ellipsis;
          overflow:hidden;
          &.active {
            color: #000;
            font-weight: bold;
            font-size: 18px;
          }
        }
      }
      .tab-history {
        display: flex;
        align-items: center;
        cursor: pointer;
        color: #666;
        font-size: 12px;
        white-space:nowrap;
        text-overflow:ellipsis;
        overflow:hidden;
      }
    }
    .tips {
      font-size: 14px;
      color: red;
      font-weight: bolder;
      margin-bottom: 10px;
    }
    .tips-third{
      color:#808080;
      font-size:14px;
      text-align:center;
      margin:15px 0;
    }
    .self-tab-box{
      width:100%;
      height:52px;
      margin:5px 0;
      padding:5px 10px;
      background:#f0f1f1;
      display:flex;
      align-items:center;
      justify-content:space-between;
      .self-tab-item{
        flex:0 0 50%;
        height:100%;
        display:flex;
        align-items:center;
        justify-content:center;
        cursor:pointer;
        font-size:16px;
        color:#333;
        &.active{
          background:#fff;
          font-weight:bold;
          color:#000;
          border-radius:5px;
        }
      }
    }
    .main-form-title {
      color: #000;
      font-size: 18px;
      display: flex;
      align-items: center;
      column-gap: 10px;
      line-height: 18px;
      font-weight: bold;
      &::before {
        content: "";
        width: 2px;
        height: 18px;
        line-height: 18px;
        background: #000;
      }
      &.mt-40 {
        margin-top: 40px;
      }
    }
    .material-list {
      width: 100%;
      display: flex;
      flex-direction: column;
      row-gap: 10px;
      /*平台面料选中列表样式开始*/
      .own-material-item {
        width: 100%;
        padding: 10px;
        position: relative;
        border: 1px solid #bfbfbf;
        border-radius: 5px;
        display: flex;
        flex-direction: column;
        .remove-icon{
          position: absolute;
          top:12px;
          right:12px;
          color:#b3b3b3;
          font-size:14px;
          cursor:pointer;
        }
        .main-info {
          width: 100%;
          display: flex;
          column-gap: 10px;
          .main-cover {
            width: 100px;
            height: 100px;
            position: relative;
            img {
              width: 100%;
              height: 100%;
            }
          }
          .info-container{
            flex:1;
            display:flex;
            flex-direction:column;
            .material-title{
              color:#1a1a1a;
              font-size:15px;
              font-weight:bold;
              text-overflow: ellipsis;
              white-space: normal;
              overflow: hidden;
              display: -webkit-box;
              line-clamp: 2;
              -webkit-line-clamp: 2;
              -webkit-box-orient: vertical;
            }
            .row-1-col{
              display:flex;
              align-items:center;
              column-gap:5px;
              .row-label{
                color:#666;
                font-size:13px;
              }
              .row-value{
                color:#1a1a1a;
                font-size:13px;
                // position:relative;
                ::v-deep select{
                  position:relative;
                  background:transparent;
                  color:#000;
                  width:fit-content;
                }
              }
            }
            .row-2-col{
              display:flex;
              align-items:center;
              column-gap:10px;
              .col-item{
                display:flex;
                align-items:center;
                column-gap:5px;
                .item-label{
                  color:#666;
                  font-size:13px;
                }
                .item-value{
                  color:#1a1a1a;
                  font-size:13px;
                }
              }
            }
          }
        }
        .use-desc{
          width:100%;
          height:40px;
          display:flex;
          align-items:center;
          column-gap:10px;
          background:#f5f5f5;
          border-radius:5px;
          padding:0 10px;
          .label{
            font-size:13px;
          }
          input{
            border:none;
            outline:none;
            background:transparent;
            flex:1;
          }
        }
      }
      /*平台面料选中列表样式结束*/
      /*客供面料/代购面料样式开始*/
      .custom-material-item{
        width: 100%;
        padding: 10px;
        position: relative;
        border: 1px solid #bfbfbf;
        border-radius: 5px;
        display: flex;
        flex-direction: column;
        .remove-icon{
          position: absolute;
          top:12px;
          right:12px;
          color:#b3b3b3;
          font-size:14px;
          cursor:pointer;
        }
        .custom-main-info{
          width: 100%;
          display: flex;
          column-gap: 10px;
          .main-cover{
            width:100px;
            height:auto;
            min-height:100px;
            display:flex;
            align-items:center;
            justify-content:center;
            flex-direction:column;
            position:relative;
            ::v-deep .ivu-upload{
              width:100%;
              text-align:center;
            }

            ::v-deep .ivu-btn-text:focus{
              box-shadow:none;
            }
            .img-box{
              width:100%;
              height:100px;
              position:relative;
              overflow:hidden;
              user-select:none;
              border:1px solid #e0e0e0;
              border-radius:5px;
              .img-list{
                width:100%;
                height:100%;
                display:flex;
                align-items:center;
                justify-content:center;
                overflow:hidden;
                img{
                  width:100%;
                  height:100%;
                  object-fit:cover;
                }
              }
              .close-btn{
                position:absolute;
                top:0;
                right:0;
                width:15px;
                height:15px;
                background:rgba(0,0,0,0.5);
                border-radius:50%;
                cursor:pointer;
                color:#fff;
                display:flex;
                align-items:center;
                justify-content:center;
                font-size:15px;
                font-weight:bold;
              }
              .prev-btn,.next-btn{
                  position:absolute;
                  top:50%;
                  transform:translateY(-50%);
                  width:15px;
                  height:15px;
                  background:rgba(0,0,0,0.5);
                  cursor:pointer;
                  color:#fff;
                  z-index:10;
                }
                .prev-btn{
                  left:0;
                }
                .next-btn{
                  right:0;
                }
            }
            .img-default{
              width:100%;
              height:100%;
              background:#f5f5f5;
              border:1px solid #e3e4e6;
              border-radius:5px;
              cursor:pointer;
              display:flex;
              align-items:center;
              justify-content:center;
              flex-direction:column;
              .img2{
                width:22px;
                height:22px;
              }
              p{
                color:#666;
                font-size:12px;
              }
            }
          }
          .custom-main-form{
            flex:1;
            display:flex;
            flex-direction:column;
            row-gap:5px;
            .form-item{
              width:100%;
              display:flex;
              align-items:center;
              column-gap:10px;
              border-bottom:1px solid #e6e6e6;
              .item-label{
                color:#666;
                font-size:13px;
                &.required::before{
                  content:"*";
                  color:red;
                }
              }
              input{
                flex:1;
                border:none;
                outline:none;
                background:transparent;
              }
            }
          }
        }
        .use-desc{
          width:100%;
          height:40px;
          display:flex;
          align-items:center;
          column-gap:10px;
          background:#f5f5f5;
          border-radius:5px;
          padding:0 10px;
          .label{
            font-size:13px;
          }
          input{
            border:none;
            outline:none;
            background:transparent;
            flex:1;
          }
        }
      }
      .add-custom-material{
        width:100%;
        height:55px;
        line-height:55px;
        text-align:center;
        color:#666;
        font-size:14px;
        border:1px solid #ccc;
        border-radius:10px;
        cursor:pointer;
        user-select:none;
      }
      /*客供面料/代购面料样式结束*/
    }
  }
  .main-content {
    flex: 1 0 1000px;
    height: 100%;
    min-height: 0;
    padding: 10px 10% 20px 0;
    .content-body {
      width: 100%;
      height: 100%;
      background: #fff;
      display: flex;
      flex-direction: column;
      padding: 10px;
      .body-top {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding-bottom: 5px;
        border-bottom: 2px solid #f6f7fa;
        .title {
          font-size: 20px;
          color: #1a1a1a;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          font-weight: bold;
        }
        .search-box {
          display: flex;
          align-items: center;
          column-gap: 10px;
          background: #f2f2f2;
          border-radius: 17px;
          padding: 8px 16px;
          input {
            flex: 1;
            border: none;
            outline: none;
            background: transparent;
          }
          .icon-search {
            width: 20px;
            height: 20px;
            cursor: pointer;
          }
        }
      }
      .content-container {
        width: 100%;
        flex: 1;
        display: flex;
        min-height:0;
        height:100%;
        position:relative;
        .side-category-list {
          flex: 0 0 115px;
          height: 100%;
          overflow-y: scroll;
          display: flex;
          flex-direction: column;
          padding: 15px 0;
          border-right: 1px solid #f6f7fa;
          // row-gap:5px;
          .category-item {
            width: 80px;
            min-height: 35px;
            display:flex;
            align-items:center;
            justify-content:center;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            cursor: pointer;
            color: #1c1c1c;
            border-radius: 5px;
            &.active {
              color: #fff;
              background: #000;
            }
          }
        }
        .content-body-container {
          flex: 1;
          display: flex;
          flex-direction: column;
          row-gap: 20px;
        //   height:100%;
          min-height: 0;
          padding: 20px 20px 30px 10px;
          .top-category-list {
            width: 100%;
            min-height:0;
            display: flex;
            flex-direction: column;
            row-gap: 5px;
            &.show-first{
              overflow:hidden;
              max-height:30px;
            }
            .top-cate-item {
              display: flex;
              align-items: flex-start;
              column-gap: 10px;
              font-size: 14px;
              .top-cate-label {
                color: #666;
                white-space:nowrap;
                flex-shrink:0;
              }
              .top-cate-list {
                display: flex;
                align-items: center;
                flex-wrap:wrap;
                gap: 5px;
                .cate-list-item {
                  color: #333;
                  padding: 1px 10px;
                  border-radius: 10px;
                  cursor: pointer;
                  &.active {
                    background: #ffecee;
                    color: #fa3d5a;
                    font-weight: 500;
                  }
                }
              }
            }
          }
          .list-container {
            flex: 1;
            width:100%;
            // height: 100%;
            display: flex;
            flex-wrap: wrap;
            gap:15px;
            align-content:flex-start;
            background: #f6f7fa;
            border-radius: 5px;
            border: 1px solid #ebedf2;
            padding: 15px;
            overflow-y:auto;
            .list-item {
              flex: 0 0 calc(100% / 5 - 15px);
              height: 160px;
              border: 1px solid #e3e4e6;
              border-radius: 5px;
              display: flex;
              flex-direction: column;
              background: #fff;
              position: relative;
              cursor: pointer;
              overflow: hidden;
              box-sizing:border-box;
              &.active {
                border: 1px solid #fa3d5a;
              }
              .check-icon {
                width: 25px;
                height: 25px;
                position: absolute;
                top: 0;
                right: 0;
                z-index: 3;
                display: block;
                box-sizing: border-box;
              }
              .cover-img-box {
                width: 100%;
                height: 126px;
                border-radius: 5px 5px 0 0;
                overflow: hidden;
                position: relative;
                img {
                  width: 100%;
                  height: 100%;
                  object-fit: contain;
                  border-radius: 5px 5px 0 0;
                }
                &:hover .img-hover {
                  position: absolute;
                  inset: 0;
                  width: 100%;
                  height: 100%;
                  border-radius: 5px 5px 0 0;
                  background: rgba(0, 0, 0, 0.5);
                  display: flex;
                  align-items: flex-end;
                  padding: 0 10px;
                  .hover-btn-box {
                    width: 100%;
                    padding-bottom: 5px;
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    .hover-btn-item {
                      color: #fff;
                      font-size: 14px;
                      font-weight: bold;
                      cursor: pointer;
                    }
                  }
                }
              }
              .name-box {
                width: 100%;
                flex: 1;
                display: flex;
                align-items: center;
                justify-content: center;
                overflow: hidden;
                color: #616366;
                font-size: 12px;
                border-top: 1px solid #e3e4e6;
                span{
                    display:block;
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                }
              }
            }
          }
        }
        .wearhouse-body{
          width:100%;
          display:flex;
          flex-direction:column;
          margin-top:20px;
          .container-tabs{
            display:flex;
            align-items:center;
            column-gap:16px;
            width:100%;
            .tab-item{
              color:#666;
              font-size:14px;
              line-height:32px;
              padding:0 16px;
              cursor:pointer;
              &.active{
                color:#fff;
                background:#ff5967;
              }
            }
          }
          .container-wh-list{
            width:100%;
            flex:1;
            // min-height:432px;
            // max-height:632px;
            background:#f6f7fa;
            margin-top:16px;
            overflow-y:auto;
            padding:20px;
            display:flex;
            flex-wrap:wrap;
            gap:28px;
            .list-item{
              // width:142px;
              width:calc(100% / 6 - 28px);
              height:175px;
              border:1px solid #e3e3e3;
              border-radius:6px;
              background:#fff;
              .cover-img{
                width:100%;
                height:142px;
                overflow:hidden;
                border-radius:6px 6px 0 0;
                position:relative;
                img{
                  width:100%;
                  height:100%;
                  object-fit:cover;
                  object-position:center;
                }
                &:hover .operate-btn{
                  width:100%;
                  height:100%;
                  background:rgba(0,0,0,0.4);
                  padding:0 8px;
                  display:flex;
                  align-items:flex-end;
                  justify-content:space-between;
                  position:absolute;
                  top:0;
                  left:0;
                  // left:0;
                  // bottom:8px;
                  .btn-item{
                    cursor: pointer;
                    color:#fff;
                    font-size:14px;
                  }
                }
              }
              .item-name{
                width:100%;
                padding:6px 8px;
                white-space:nowrap;
                text-overflow:ellipsis;
                overflow:hidden;
              }
            }
          }
        }


        .color-mask {
            position: absolute;
            top: 0;
            right: 0;
            left: 0;
            bottom: 0;
            background: rgba(0, 0, 0, 0.35);
            z-index: 200;
            .color-wrap {
            position: absolute;
            width: 640px;
            height: 400px;
            top: calc(50% - 200px);
            left: calc(50% - 320px);
            background: white;
            border-radius: 10px;
            z-index: 10000;
            padding: 20px 20px 0 20px;

            .title {
                font-size: 16px;
                font-weight: bold;
                color: #1a1a1a;
            }

            .color-list {
                display: flex;
                flex-wrap: wrap;
                align-items:flex-start;
                width: 600px;
                height: 100%;
                min-height: 150px;
                max-height: 280px;
                overflow-y: auto;
                column-gap: 10px;
                row-gap: 10px;

                .color-item {
                user-select:none;
                width: 180px;
                border:1px solid #e3e3e3;
                border-radius:4px;
                padding:8px;
                display:flex;
                flex-direction:column;
                row-gap:4px;
                cursor:pointer;
                &.active{
                  border:1px solid #ff5967;
                }
                .item-top{
                  display:flex;
                  align-items:center;
                  column-gap: 8px;
                  position: relative;
                  .color-img, .rgb-value{
                    width:30px;
                    height:30px;
                    border:1px solid #e3e3e3;
                    border-radius:4px;
                    flex-shrink:0;
                  }
                  img {
                    width: 30px;
                    height: 30px;
                    flex-shrink:0;
                  }
                  .color-name{
                    font-size:12px;
                    color:#333;
                    font-weight:500;
                  }
                }
                .info-item{
                  display:flex;
                  align-items:center;
                  column-gap:5px;
                  .label{
                    color:#999;
                    font-size:12px;
                    flex-shrink:0;
                  }
                  .value{
                    color:#666;
                    font-size:12px;
                    white-space:pre-wrap;
                    word-break:break-all;
                  }
                }
                }
            }

            .btn-group {
                margin-top: 24px;
                display: flex;
                justify-content: flex-end;
                align-items: center;
                border-top: 1px solid #e5e5e5;
                height: 58px;

                .btn {
                width: 100px;
                height: 38px;
                line-height: 38px;
                border-radius: 5px;
                text-align: center;
                font-size: 14px;
                margin: 0 7px;
                cursor: pointer;

                &.btn-cancel {
                    color: black;
                    border: 1px solid #e5e5e5;
                }

                &.btn-confirm {
                    color: white;
                    background: #fa3d5a;
                }
                }
            }
            }
        }
      }
      .daigou-content {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        height:100%;
        .daigou-img {
          width: 50px;
          height: 50px;
          margin-bottom: 29px;
        }
        .daigou-sub-title {
          color: #1a1a1a;
          font-weight: 500;
          font-size: 22px;
          margin-bottom: 28px;
        }
        p {
          color: #4d4d4d;
          font-size: 14px;
          line-height: 30px;
        }
      }
      .history-team-box {
              display: flex;
              border-top: 1px solid #f6f7fa;
              margin-top: 14px;
              .my-pattern-menu {
                flex: 1;
                max-width: 198px;
                height: 100%;
                display: flex;
                flex-direction: column;
                row-gap: 10px;
                padding: 0 20px;
                margin-top: 9px;
                .menu-parent-item {
                  width: 100%;
                  height: 35px;
                  display: flex;
                  align-items: center;
                  column-gap: 10px;
                  color: #1c1c1c;
                  font-size: 14px;
                  padding-left: 10px;
                  padding-right: 4px;
                  white-space: nowrap;
                  overflow: hidden;
                  text-overflow: ellipsis;
                  cursor: pointer;
                  &.active {
                    background: #1c1c1c;
                    border-radius: 5px;
                    color: #ffffff;
                  }
                  .menu-icon {
                    width: 20px;
                    height: 20px;
                  }
                  .label-name {
                    flex: 1;
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                  }
                }
                ul {
                  margin-left: 39px;
                  li {
                    list-style-type: square;
                    position: relative;
                    cursor: pointer;
                    color: #4d4d4d;
                    font-size: 14px;
                    line-height: 40px;
                    span {
                      display: block;
                      white-space: nowrap;
                      overflow: hidden;
                      text-overflow: ellipsis;
                      width: 100%;
                    }

                    &::marker {
                      font-size: 18px;
                    }

                    &:hover,
                    &.active-team {
                      color: #ff5967;
                    }
                  }
                }
              }

              .history-tag-box {
                width: 100%;
                display: flex;
                align-items: center;
                justify-content: space-between;
                flex-wrap: wrap;
                margin-top: 13px;
                // margin-bottom:15px;
                .history-tab {
                  display: flex;
                  align-items: center;
                  gap: 20px;
                  .tag-item {
                    color: #4d4d4d;
                    font-size: 14px;
                    padding: 9px 16px;
                    cursor: pointer;
                    &.active {
                      // background:#1c1c1c;
                      // color:#ffffff;
                      // border-radius:5px;
                      color: #fb486d;
                      font-weight: bold;
                      border-radius: 24px;
                      background: rgba(251, 72, 109, 0.1);
                    }
                  }
                }

                .batch-box {
                  display: flex;
                  align-items: center;
                  font-size: 14px;
                  justify-content: flex-end;
                  column-gap: 20px;
                  .batch-btn {
                    color: #666666;
                    cursor: pointer;
                  }
                }

                .tag-item-folder {
                  color: #4d4d4d;
                  font-size: 14px;
                  padding: 8px 16px;
                  cursor: pointer;
                  &.folder-item-active {
                    color: #fb486d;
                    font-weight: bold;
                    border-radius: 24px;
                    background: rgba(251, 72, 109, 0.1);
                  }
                }
              }

              table {
                display: table;
                width: 100%;
                table-layout: fixed;
                margin-top: 15px;
                border-collapse: collapse;
                thead {
                  display: table;
                  table-layout: fixed;
                  width: 100%;
                  tr {
                    background: #fafafa;
                    color: #808080;
                    th {
                      padding: 19px 0;
                      text-align: center;
                      width: 40%;
                      &:nth-child(3) {
                        width: 20%;
                        // min-width:200px;
                      }
                    }
                  }
                }
                tbody {
                  display: block;
                  width: 100%;
                  height: 50vh;
                  overflow-y: auto;
                  tr {
                    width: 100%;
                    display: table;
                    table-layout: fixed;
                    &:hover {
                      background: #fafafa;
                    }
                    td {
                      width: 40%;
                      &:nth-child(3) {
                        width: 20%;
                      }
                      padding: 15px 0;
                      text-align: center;
                      .info-box {
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        column-gap: 10px;
                        width: fit-content;
                        .cover-img {
                          width: 50px;
                          height: 50px;
                          border-radius: 5px;
                          border: 1px solid #e3e4e6;
                          background: #ffffff;
                        }
                        .info {
                          display: flex;
                          flex-direction: column;
                          align-items: flex-start;
                          justify-content: center;
                          text-align: left;
                          row-gap: 3px;
                          // flex:1;
                          width: 100%;
                          .info-title {
                            color: #1a1a1a;
                            font-size: 14px;
                            width: fit-content;
                            flex: 1;
                            white-space: nowrap;
                            overflow: hidden;
                            text-overflow: ellipsis;
                            .title-tag {
                              font-size: 12px;
                              &.platform {
                                color: #0caea8;
                              }
                              &.custom {
                                color: #3f7aca;
                              }
                            }
                          }
                          .info-key {
                            color: #666666;
                            font-size: 12px;
                            width: 100%;
                            white-space: nowrap;
                            overflow: hidden;
                            text-overflow: ellipsis;
                          }
                        }
                      }
                      .operation-col {
                        display: flex;
                        flex-direction: column; // 改为垂直排列可能更适合窄列，或者保持 row 但换行
                        align-items: center;
                        justify-content: center;
                        gap: 5px;
                        width: 100%;

                        .operation {
                          display: flex;
                          align-items: center;
                          justify-content: center;
                          column-gap: 5px;

                          span {
                            font-size: 12px;
                            color: #cccccc;
                          }

                          .btn {
                            color: #666666;
                            font-size: 12px;
                            white-space: nowrap;
                            cursor: pointer;
                            padding: 2px 5px; // 增加点击区域

                            &:hover {
                              color: #fa424f;
                            }
                          }
                        }

                        .join-team {
                          color: #666666;
                          font-size: 12px;
                          cursor: pointer;
                          white-space: nowrap;

                          &:hover {
                            color: #fa424f;
                          }
                        }
                      }
                      // .operation-col {
                      //   display: flex;
                      //   justify-content: space-between;
                      //   width: 100%;
                      //   .operation {
                      //     display: flex;
                      //     align-items: center;
                      //     justify-content: center;
                      //     column-gap: 5px;
                      //     span {
                      //       font-size: 12px;
                      //       color: #cccccc;
                      //     }
                      //     .btn {
                      //       color: #666666;
                      //       font-size: 12px;
                      //       cursor: pointer;
                      //       &:hover {
                      //         color: #fa424f;
                      //       }
                      //     }
                      //   }
                      //   .join-team {
                      //     color: #666666;
                      //     font-size: 12px;
                      //     cursor: pointer;
                      //     &:hover {
                      //       color: #fa424f;
                      //     }
                      //   }
                      // }
                    }
                  }
                }
              }
              .team-file {
                table {
                  width: 100%;
                  border-collapse: collapse;
                  border-spacing: 0 9px;
                  table-layout: fixed;
                  border: none;
                  thead {
                    text-align: center;
                    tr {
                      background: #fcfcfd;
                      border-radius: 5px;
                      height: 36px;
                      th {
                        color: #808080;
                        font-size: 14px;
                        line-height: 36px;
                      }
                    }
                  }

                  tbody {
                    tr {
                      border-radius: 5px;
                      overflow: hidden;
                      background-color: white;
                      cursor: pointer;
                      &:hover {
                        background: #fafafa;
                      }
                      &.tr-active {
                        outline: 1px solid #ff5967;
                        position: relative;
                      }
                      td {
                        position: relative;
                        .selected-icon {
                          position: absolute;
                          top: 0;
                          right: 0;
                          width: 25px;
                          height: 25px;
                        }
                        .info-container {
                          padding: 8px;
                          display: flex;
                          align-items: center;
                          column-gap: 14px;
                          .cover-img {
                            width: 50px;
                            height: 50px;
                            border-radius: 3px;
                            border: 1px solid #e3e4e6;
                            flex-shrink: 0;
                          }
                          .item-info {
                            display: flex;
                            flex-direction: column;
                            row-gap: 10px;
                            // width:100%;
                            flex: 1;
                            .title {
                              display: flex;
                              align-items: center;
                              .main {
                                color: #1a1a1a;
                                font-size: 14px;
                                font-weight: bold;
                                width: fit-content;
                                text-overflow: ellipsis;
                                overflow: hidden;
                                white-space: nowrap;
                              }
                              .sub {
                                font-size: 12px;
                                margin-left: 5px;
                                flex-shrink: 0;
                                &.custom-pattern {
                                  color: #3f7aca;
                                }
                                &.own-pattern {
                                  color: #0caea8;
                                }
                              }
                            }
                            .info {
                              color: #666666;
                              font-size: 12px;
                              line-height: 20px;
                              width: 100%;
                              white-space: nowrap;
                              overflow: hidden;
                              text-overflow: ellipsis;
                              text-align: left;
                            }
                          }
                        }
                        .style-col {
                          width: 100%;
                          text-align: center;
                          white-space: nowrap;
                          overflow: hidden;
                          text-overflow: ellipsis;
                        }
                        .operation-col {
                          display: flex;
                          align-items: center;
                          justify-content: center;
                          column-gap: 40px;
                          .left-operation {
                            display: flex;
                            align-items: center;
                            column-gap: 10px;
                            font-size: 12px;
                            .btn {
                              cursor: pointer;
                              color: #666666;
                              &.btn-active,
                              &:hover {
                                color: #fa3d5a;
                              }
                            }
                            .line {
                              color: #cccccc;
                            }
                          }
                          .add-to-team {
                            color: #666666;
                            font-size: 12px;
                            cursor: pointer;
                            &:hover {
                              color: #fa3d5a;
                            }
                          }
                        }
                      }
                    }
                  }

                  /* 设置单元格的样式以配合圆角效果 */
                  td,
                  th {
                    border: none;
                    // border: 1px solid #e8eaec;
                    padding: 8px;
                    &:first-child {
                      border-radius: 5px 0 0 5px; /* 第一列单元格左上、左下圆角 */
                    }
                    &:last-child {
                      border-radius: 0 5px 5px 0; /* 最后一列单元格右上、右下圆角 */
                    }
                    &:first-child:last-child {
                      border-radius: 5px; /* 只有一个单元格时应用全部圆角 */
                    }
                  }
                }
              }
              .page-container {
                width: 100%;
                border-top: 1px solid #e0e0e0;
              }
            }
    }
  }
}

.flex-container{
  display:flex;
  align-items:center;
  justify-content:space-between;
}

.show-more-cate{
  width:88px;
  height:28px;
  border-radius:4px;
  display:flex;
  align-items:center;
  justify-content:center;
  column-gap:4px;
  font-size:14px;
  cursor:pointer;
  color:#333;
  border:1px solid #e3e3e3;
  user-select:none;
  &.show-all{
    color:#ff5967;
    border:1px solid #ff5967;
  }
}

.upload-other{
  width:100%;
  height:56px;
  border-radius:5px;
  border: 1px solid #b3b3b3;
  color: #1d1d1d;
  font-size: 14px;
  display:flex;
  align-items:center;
  justify-content:center;
  margin-top:20px;
  cursor:pointer;
  .icon{
    width:24px;
    height:24px;
  }
}

.other-file-list {
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  .file-box {
    display: flex;
    align-items: center;
    width: 100%;
    height: 42px;
    background: #f3f3f3;
    position: relative;
    margin: 10px 5px;
    .file-item {
      position: relative;
      line-height: 42px;
      color: #1a1a1a;
      font-size: 12px;
      padding-left: 55px;
      .icon-doc {
        position: absolute;
        top: 5px;
        left: 15px;
        width: 32px;
        height: 32px;
      }
    }
    .icon-del {
      position: absolute;
      top: 12px;
      right: 15px;
      width: 20px;
      height: 20px;
      z-index: 10;
    }
    .replace-file {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100px;
      background: rgba(0, 0, 0, 0.4);
      color: #ffffff;
      font-size: 13px;
      cursor: pointer;
      .ico {
        width: 18px;
        height: 18px;
      }
    }
  }
}


.demo-spin-icon-load{
    animation: ani-demo-spin 1s linear infinite;
}
@keyframes ani-demo-spin {
    from { transform: rotate(0deg);}
    50%  { transform: rotate(180deg);}
    to   { transform: rotate(360deg);}
}

::v-deep .popup-modal {
  /* 核心容器 */
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999;
  background: rgba(0, 0, 0, 0.6);

  /* 弹窗内容区 */
  .popup-content {
    background: #fff;
    border-radius: 10px;
    //   width: min(980px, 92vw); // 最大980px，最小占92%视口宽
    /* 修正后 */
    width: max(980px, 96vw); // 增加视口占比
    min-width: 320px; // 保障最小可操作宽度
    max-width: none !important; // 移除潜在限制

    /* 添加边距保护 */
    margin: 0 2vw; // 左右留白
    box-sizing: content-box; // 防止padding影响
    max-height: max(720px, 85vh); // 最大720px，最小占85%视口高
    min-height: 30vh;
    display: flex;
    flex-direction: column;
    overflow: hidden;
  }
}

.fabric-content-wrap {
  margin-top: 40px;
  overflow-y: scroll;
  height: 600px;
  position: relative;
  display: flex;
  flex-direction: column;
  .title-box {
    display: flex;
    align-items: center;
    column-gap: 13px;
    .title {
      color: #1a1a1a;
      font-size: 16px;
      border-left: none;
      font-weight: bold;
      margin-bottom: 0;
      padding: 10px 0;
      height: auto;
    }
    .line {
      flex: 1;
      height: 1px;
      background: #ebebeb;
    }
  }

  .info-wrap {
    display: flex;
    justify-content: space-around;
    // min-height: 430px;

    .left-popup {
      width: 420px;
      border: 1px solid #e5e5e5;
      display:flex;
      align-items:center;
      .f-img {
        width: 420px;
        height: 420px;
      }
    }

    .right {
      // width: 500px;
      flex: 1;
      padding-right: 20px;
      padding-left: 20px;
      .name {
        color: #1a1a1a;
        font-size: 20px;
      }

      .no {
        color: #808080;
        font-size: 14px;
        margin-bottom: 20px;
        // margin: 25px 0;
      }
      .price {
        color: #e00000;
        font-size: 18px;
        font-weight: bold;
        padding-bottom: 17px;
      }
      .item {
        margin: 5px 0;

        .key {
          display: inline-block;
          color: #808080;
          // width: 80px;
        }

        .value {
          color: #1a1a1a;
        }
      }
      .color-title {
        color: #1a1a1a;
        font-size: 16px;
        font-weight: bold;
      }
      .color-box {
        width: 100%;
        display: flex;
        flex-wrap: wrap;
        column-gap: 10px;
        row-gap: 10px;
        margin-top: 26px;
        max-height: 200px;
        overflow-y: auto;
        .color-items{
          user-select:none;
          width:180px;
          border:1px solid #e3e3e3;
          border-radius:4px;
          padding:8px;
          display:flex;
          flex-direction:column;
          row-gap:4px;
          &.active{
            border:1px solid #ff5967;
          }
          .item-top{
            display:flex;
            align-items:center;
            column-gap: 8px;
            position: relative;
            .color-img{
              width:30px;
              height:30px;
              border:1px solid #e3e3e3;
              border-radius:4px;
            }
            .color-name{
              font-size:12px;
              color:#333;
              font-weight:500;
            }
          }
          .info-item{
            display:flex;
            align-items:center;
            column-gap:5px;
            .label{
              color:#999;
              font-size:12px;
              flex-shrink:0;
            }
            .value{
              color:#666;
              font-size:12px;
              white-space:pre-wrap;
              word-break:break-all;
            }
          }
        }
        // .color-item {
        //   width: 112px;
        //   height: 40px;
        //   display: flex;
        //   align-items: center;
        //   justify-content: center;
        //   column-gap: 6px;
        //   border-radius: 5px;
        //   border: 1px solid #e5e5e5;
        //   color: #4d4d4d;
        //   cursor: pointer;
        //   white-space:nowrap;
        //   text-overflow:ellipsis;
        //   overflow:hidden;
        //   .color-img {
        //     width: 25px;
        //     height: 25px;
        //     border-radius: 5px;
        //   }
        //   &.active {
        //     border: 1px solid #fa3d5a;
        //     color: #fa3d5a;
        //   }
        // }
      }
    }
  }

  .color-box {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    column-gap: 10px;
    row-gap: 10px;
    .color-items{
          user-select:none;
          width:180px;
          border:1px solid #e3e3e3;
          border-radius:4px;
          padding:8px;
          display:flex;
          flex-direction:column;
          row-gap:4px;
          cursor:pointer;
          &.active{
            border:1px solid #ff5967;
          }
          .item-top{
            display:flex;
            align-items:center;
            column-gap: 8px;
            position: relative;
            .color-img{
              width:30px;
              height:30px;
              border:1px solid #e3e3e3;
              border-radius:4px;
            }
            .color-name{
              font-size:12px;
              color:#333;
              font-weight:500;
            }
          }
          .info-item{
            display:flex;
            align-items:center;
            column-gap:5px;
            .label{
              color:#999;
              font-size:12px;
              flex-shrink:0;
            }
            .value{
              color:#666;
              font-size:12px;
              white-space:pre-wrap;
              word-break:break-all;
            }
          }
        }
    // .color-item {
    //   width: 112px;
    //   height: 40px;
    //   display: flex;
    //   align-items: center;
    //   justify-content: center;
    //   column-gap: 6px;
    //   border-radius: 5px;
    //   border: 1px solid #e5e5e5;
    //   color: #4d4d4d;
    //   cursor: pointer;
    //   .color-img {
    //     width: 25px;
    //     height: 25px;
    //     border-radius: 5px;
    //   }
    //   &.active {
    //     border: 1px solid #fa3d5a;
    //     color: #fa3d5a;
    //   }
    // }
  }

  .richtext-wrap {
    flex: 1;
    padding-bottom: 60px;
  }
  .btn-box {
    display: flex;
    justify-content: center;
    column-gap: 20px;
    position: sticky;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 1;
    background: #ffffff;
    padding: 10px 0;
    .cancel-btn {
      width: 120px;
      height: 38px;
      border-radius: 19px;
      background: #ffffff;
      border: 1px solid #e5e5e5;
      color: #1a1a1a;
      font-size: 14px;
      cursor: pointer;
    }
    .confirm-btn {
      width: 120px;
      height: 38px;
      border-radius: 19px;
      background: #1a1a1a;
      color: #ffffff;
      font-size: 14px;
      cursor: pointer;
    }
  }
}

.slider {
  width: 420px;
  height: 420px;
  overflow: hidden;

  .swiper-slide {
    width: 420px;
    height: 420px;
  }

  .img,
  video {
    width: 420px;
    height: 420px;
    object-fit: contain;
  }
}

::v-deep .viewer-container {
  z-index: 999999 !important;
}

::v-deep .ivu-upload{
    width:100%;
}

select {
  position: absolute;
  top: 0;
  left: 0;
  width: 70px;
  height: 25px;
  background: rgba(0, 0, 0, 0.5);
  border-radius: 5px;
  color: white;
  z-index: 50;
  border: none;
  outline: none;
}

.hidden-image-list {
  position: absolute;
  left: -9999px;
  top: 0;
  opacity: 0;
  pointer-events: none;
}
</style>
